const locales = [
  {
    item: {
      name: 'en',
      descriptive: {
        PRODUCT_NAME: '',
        PRODUCT_LOGO:
          'data:image/svg+xml;base64,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',
        ACTION: 'Action | Actions',
        ACTION_CLICK: 'Click',
        ACTION_FOCUS: 'Focus',
        ACTION_INPUT: 'Input',
        ACTION_READ: 'Read',
        ADD: 'Add {thing}',
        ADD_ITEM_CONFIRM: 'Are you sure you want to add item {thing}?',
        ALL_REQUIRED_FIELDS: 'all required fields',
        ALLOW_CAMERA_MICROPHONE: 'Allow camera/microphone use',
        ANALYTICS: 'Analytics',
        ANNOTATION: 'Annotation',
        APPLICATION: 'app | apps',
        APPLICATION_IDENTITY_SECTION: 'Application identity',
        APPLICATION_IS_EMBEDDED: 'Embedded app',
        APPLICATION_LEGACY_BROWSER: 'Legacy IE',
        APPLICATION_ALREADY_EXISTS_WARN:
          'Application you are trying to import already exists. Import may result in overriding some of the existing data.',
        AUTHENTICATE: 'Authenticate',
        AUTHENTICATE_TIP: 'Please make sure your username and password are correct and try again',
        BLACKBOX: 'Blackbox',
        BASIC_SETUP: 'Basic setup',
        BEAUTIFY_CODE: 'Beautify',
        BLOCKLY: 'blocks',
        BLOCKLY_CHANGE_WARN:
          'Direct code change detected. Proceed and remove the now outdated block diagram?',
        BLOCKLY_EMPTY_HEADER: 'There are no blocks for this flow (yet)',
        BLOCKLY_EMPTY_MESSAGE:
          "You can generate blocks corresponding to this flow's code by pressing the button below. You can go back and directly edit the code any time. This will remove the block diagram.",
        BLOCKLY_EMPTY_WARN:
          "Note that the first time you interact with the generated block diagram, the current flow code will be replaced with code generated from the blocks. Use the history feature to undo this, if you don't like the result.",
        BLOCKLY_GENERATE_BUTTON: 'Generate blocks',
        BLOCKLY_GENERATE_MEDIUM_CODE_MSG:
          'Note that block programming works best for small flows. Are you sure you want to continue?',
        BLOCKLY_GENERATE_LARGE_CODE_MSG:
          'NOTE: Your flow is getting pretty big. The block editor will most likely struggle with so many blocks. Are you sure about this?',
        BLOCKLY_BAD_XML_HEADER: 'The block diagram is invalid',
        BLOCKLY_BAD_XML_MESSAGE:
          'Please include the flow code and the following message when you report the bug:',
        SINCE: 'Since',
        FAILED_CHANGE_TAG: 'Failed to change a tag. Tags should be unique and non-empty',
        FAILED_REMOVE_TAG: 'Failed to remove a tag',
        TAG_CHANGED: 'Tag changed',
        TAG_REMOVED: 'Tag removed',
        CHANGELOG: 'Changelog',
        CHANGES_SELECT: 'Select changes to compare',
        CLEAR_CONSOLE: 'Clear console',
        CODE_EDITOR_MENU_SEARCH_HELP: 'Enter text to search for snippets',
        CODE_EDITOR_MENU_SEARCH_NO_RESULTS: 'None found',
        CODE_EDITOR_MENU_OVERFLOW_MESSAGE:
          'Too many results. Futher limit the search to see all matches',
        CONSOLE_OUTPUT: 'Console output',
        COPY_TO_CLIPBOARD: 'Copy to clipboard',
        DEBUGGER: 'Debugger',
        DEBUGGER_CONNECTION_ERROR: 'Error establishing debugger connection',
        EXPORT_TO_JSON: 'Export to json',
        HIDE_FROM_USER: 'Hide {thing} from user',
        NO_CHANGES:
          '<p>No changes in the <em>selected date interval</em>.</p></p>Try selecting a date further back in time.</p>',
        TAGGED_ONLY: 'Tags only',
        TIME: 'Time',
        TIMESTAMP: 'Timestamp',
        LOG: 'Log',
        LOG_TRUNCATED: 'Only the last {maxLines} of the log are shown...',
        AUTHOR: 'author',
        TAG: 'Tag',
        ENTER_TAG: 'Enter tag',
        REVERT: 'Revert',
        REVERTED: 'Reverted {thing}',
        REVERT_ACTION: 'Revert {thing}',
        REVERT_TOOLTIP: 'Revert to this version',
        CHANGE: 'You are looking at {tag} from {fromNow}',
        UNTAGGED: 'a version',
        CHANGE_ABORT: 'Cancel',
        CHANGE_REVERT: 'Revert to this version',
        CODE: 'Code',
        COLOR: 'Color',
        CONFIGURATION: 'Configuration',
        APPLY_SETTINGS: 'Apply settings',
        COPY: 'Copy {thing}',
        COPY_CONFIRM: 'Are you sure you want to copy {thing}?',
        COPIED: 'Copied {thing}',
        COPIED_BY: 'copied by {name}',
        CREATE: 'Create {thing} {name}',
        CREATED: 'Created {thing}',
        DASHBOARD: 'Dashboard',
        DELAY: 'Delay',
        DELETE: 'Delete {thing}',
        DELETE_CONFIRM_MESSAGE: 'Are you sure you want do delete {thingType} {thingName}?',
        DELETED: 'Deleted {thing}',
        DESCRIPTION: 'Description',
        DISABLE_AUTOSAVE: 'Disable code autosave in flows associated with this group',
        DISABLE_FLOW_CODE_EDITING: 'Disable code editing in flows associated with this group',
        EDIT: 'Edit {thing} {name}',
        ENTER_CUESTA: 'Sign in to {productName}',
        EMAIL: 'Email',
        ERR: 'Failed to {action}',
        ERR_OUTDATED_VERSION: 'Failed to {action}. Your version of the {thing} is not up to date.',
        ERR_NOT_UNIQUE: 'Failed to {action}. The {thing} with that {property} already exists.',
        EXECUTABLE: 'Executable',
        EXECUTABLE_PATH_CONTAINS: 'Executable-path contains',
        FIELD: 'field | fields',

        FIELD_POINT_AND_CLICK: 'Point and click',
        FIELD_SETTINGS: 'Settings',
        FIELD_IDENTIFICATION_TYPE: 'Locator type',
        FIELD_PATH_IDENTIFICATION: 'Path',
        FIELD_OPTICAL_IDENTIFICATION: 'Optical',
        FIELD_TESTING: 'Test',
        FIELD_TEST_CLICK: 'Click',
        FIELD_TEST_RUN: 'Run',
        FIELD_TEST_MISC: 'Misc',
        FIELD_ALTERNATIVE_DELETE: 'Remove',
        FIELD_ALTERNATIVE_DELETE_CONFIRM: 'Do you want to delete this locator?',
        FIELD_LOCATOR_IMAGE: 'Image',
        FIELD_LOCATOR: 'locator',
        FIELD_LOCATOR_INCLUDE_INVISIBLE: 'include invisible',
        FIELD_PRIMARY: 'Primary {type}',
        FIELD_ALTERNATIVE: 'Backup {type} #{index}',
        FIELD_USE_PATH_EDITOR: 'Highlight path elements',
        FIELDS_AND_FLOWS: 'Flows & Fields',
        FIELD_NOT_USED: 'Field is not used in any flow',
        FIELD_ALTERNATIVE_EMPTY: 'This locator is empty',
        FILTER_BY: 'Filter by {thing}',
        FLOW_NOT_USED: 'Flow is not used in any flow',
        FLOW: 'flow | flows',
        FLOW_COUNT: 'no flows | one flow | {count} flows',
        FLOWS_APPLICATION_WARNING: "Flow's application is not in the group",
        FLOW_EDIT_NOT_FOR_THIS_MAINTAINER: 'Flow edit is not allowed for this user.',
        FRAME_CONTAINS: 'Frame contains',
        GLOBAL_SEARCH: 'Global search',
        GROUP: 'group | groups',
        GROUP_BY: 'Group by {thing}',
        GROUP_GENERAL_SETTINGS: 'Group general settings',
        GROUP_NOT_IN_APPLICATION: 'Selected group {group} is not present on the application',
        GROUP_ADD_TO_APP_QUESTION:
          'The group {group} is not on the parent app. Would you like to add it to {app} now?',
        GROUP_ADD_TO_APP_FAILURE: 'Adding {group} to {app} failed!',
        GROUP_FLOW_SETTINGS: 'Group flow settings',
        IMPORT_FROM_FILE_ERROR: 'Error while importing {thing} from file',
        INPUT: 'input | inputs',
        INPUT_HERE: 'your input here',
        INCLUDED_MODULE_FLOW_WITH_UNDEFINED_FIELDS:
          'Some of the included module flows ({flows}) reference fields, which are undefined for this application',
        IDENTIFYING_FLOW_NAME: '{appName} {appVersion} / {flowName}',
        IDENTIFYING_APP_NAME: '{appName} {appVersion}',
        'JAVA-AWT': 'Java AWT',
        'JAVA-AWT-DESCRIPTION':
          "Connects to local java applications. Can start the application if isn't already running",
        'JAVA-SWING': 'Java Swing',
        KEY: 'Key',
        LANGUAGE: 'language',
        LANGUAGE_ES5: 'legacy Javascript (ES5)',
        LANGUAGE_MODERN: 'modern Javascript',
        LAUNCH_SECTION: 'Startup with parameters',
        LAUNCH_SECTION_FLOW: 'Startup with flow',
        LAUNCHWITH: 'Launch with',
        LAUNCHTIMEOUT: 'Launch timeout',
        TRIGGER_NO_LAUNCH: 'Only run flow if app is already attached',
        LAST_EDITED_BY: 'Last edited by',
        LESS_SETTINGS: 'Fewer settings',
        LOADING: 'Loading...',
        LOGIN: 'Login',
        LOGOUT: 'Logout',
        LAUNCH_WITH: 'Launch with...',
        MAINTAINER: 'Maintainer | Maintainers',
        MANUFACTURER: 'manufacturer | manufacturers',
        MORE_SETTINGS: 'More settings',
        MQ: 'Message Queue',
        MQ_CONFIG_ENCODING: 'Encoding',
        MQ_CONFIG_EXCHANGE: 'Exchange',
        MQ_CONFIG_HOST: 'Host',
        MQ_CONFIG_PORT: 'Port',
        MQ_CONFIG_QUEUE_NAME: 'Queue name',
        MQ_CONFIG_ROUTING_KEY: 'Routing key',
        MQ_CONFIG_USER: 'User',
        MQ_CONFIG_PASS: 'Password',
        MQ_CONFIG_VHOST: 'Virtual host',
        MQ_META: 'Messages published to queue {serviceName}',
        MQ_SERVICE: 'Message queue',
        MQ_SERVICE_TRIGGER: 'Message queue trigger',
        MQ_SETTINGS: 'Message queue settings',
        MQ_TRIGGER_CLAIM_MATCH: 'Required JWT claim',
        MQ_TRIGGER_MESSAGE_MATCH: 'Message body pattern',
        MQ_TRIGGER_REPLY_EXPECTED: 'Reply to sender',
        NAME: 'Name',
        NAMED: 'Named',
        NATIVE: 'Window Native',
        'NATIVE-DESCRIPTION':
          "Connects to windows applications. Can start the application if it isn't already running",
        NEW: 'New {thing}',
        ENABLE_DEBUGGER: 'Enable debugger',
        NO_ITEMS_MATCH: 'No {things} matched your search',
        NO_SELECTION: 'No selection',
        NO_THING_YET: 'No {thing} yet',
        NO_MORE_ITEMS: 'No more items',
        OPEN_PAGE_IN: 'Open page in',
        OPEN_PAGE_IN_APP: 'App window',
        OPEN_PAGE_IN_INCOGNITO: 'Incognito window',
        OPEN_PAGE_IN_TAB: 'New tab',
        OPEN_PAGE_IN_WINDOW: 'New window',
        OPTIONS: 'Options',
        OR: 'or',
        OR_SHORT: 'or',
        OUTPUT: 'output | outputs',
        UNSAVED_CHANGES: 'You have unsaved changes. Do you want to leave and discard your changes?',
        PINMENU: 'Pin menu',
        PROCESS_CONTAINS: 'Process-name contains',
        PROCESS_PATH_CONTAINS: 'Process-path contains',
        PROMPT_ON_ADD_MESSAGE: 'Prompt on add message',
        PROMPT_ON_REMOVE_MESSAGE: 'Prompt on remove message',
        PROMPT_ON_ADD: 'Prompt for confirmation before adding this group',
        PROMPT_ON_REMOVE: 'Prompt for confirmation before removing this group',
        UPLOAD: 'Upload {thing}',
        UPLOADED: 'Uploaded',
        USERNAME: 'Username',
        PASSWORD: 'Password',
        PATH: 'Path',
        READ: 'Read {thing}',
        REGEX: 'Regex',
        REGEX_HINT: 'Regex',
        REMOVE_ITEM_CONFIRM: 'Are you sure you want to remove item {thing}?',
        RESET_COLOR: 'Reset color',
        SEARCH: 'Search',
        SEARCH_IN: 'Search in {thing}',
        SERIALPORT: 'Serial port',
        SERIALPORT_BAUD: 'Baud',
        SERIALPORT_DATABITS: 'Data bits',
        SERIALPORT_ENCODING: 'Encoding',
        SERIALPORT_HANDSHAKE: 'Handshake',
        SERIALPORT_MESSAGE_MATCH: 'Trigger text',
        SERIALPORT_META: '{serviceName} sends message matching {messagePattern}',
        SERIALPORT_PARITY: 'Parity',
        SERIALPORT_PORT_PATTERN: 'Port name',
        SERIALPORT_SERVICE: 'Serial port | Serial ports',
        SERIALPORT_SERVICE_TRIGGER: 'Serial port messages',
        SERIALPORT_SETTINGS: 'Port settings',
        SERIALPORT_STOPBITS: 'Stop bits',
        SERVICE_TRIGGER: 'Service trigger',
        SETTINGS: 'Settings',
        SHORTCUTS_GLOBAL: 'Global shortcuts',
        SHORTCUTS_WINDOW: 'Window specific shortcuts',
        STATE: 'State',
        SUBJECT: 'subject | subjects',
        SUBJECTPREFIX: 'Subject prefix | Subject prefixes',
        SUPERFLOWS: 'Superflow | Superflows',
        STOP: 'Stop',
        TITLEBAR_CONTAINS: 'Title bar contains',
        TRY_AGAIN: 'Please try again',
        TYPE: 'type | types',
        FLOW_TYPE: 'type of flow',
        TYPE_CONFIG: 'Type Config',
        UNDEFINED_CONSTRAINT: 'Your code contains undefined {things}.', // Unused
        UNDEFINED_CONSTRAINT_ELEMENTS: 'Undefined {things}: {list}.', // Unused
        UNDEFINED_CONSTRAINT_EX: 'In order to {action}, remove {subjects}: {list}.', // Unused
        UNDEFINED_REFERENCE_ERROR: "The {thing} '{thingName}' is undefined",
        INCLUDE_WITH_BAD_REFERENCES_ERROR:
          "The module '{name}' references invalid fields for this app:\n{lines}",
        UNIQUE_CONSTRAINT: '{thing} must be unique.',
        UNIQUE_CONSTRAINT_EX: 'There is a {thing} {verb} {subject} already.',
        UPDATE: 'Update {thing}',
        UPDATE_HELP: 'Save your changes',
        UPDATED: 'Updated {thing}',
        UNKNOWN: 'Unknown',
        UNKNOWN_ERROR: 'Unknown error',
        USED_CONSTRAINT: '{thing} is used in the app.',
        USED_CONSTRAINT_EX: 'In order to {action}, please remove it from {list}.',
        USED_IN: 'Used in {thing}',
        USER: 'user | users',
        NO_USER_HEADER: 'Missing user',
        NO_USER_BODY:
          'There is no user with {withName} as their username. Create a new user by clicking the link below and specify your username as the name.',
        URL_CONTAINS: 'URL contains',
        VERSION: 'Version | Versions',
        VIEW: 'View',
        WARN_REQUIRED: 'In order to {action}, please provide a value for {thing}.',
        WARN_INCORRECT_INPUT:
          'In order to {action}, please provide valid values for indicated fields',
        WARN_OUTDATED:
          "{thing} was updated by someone else. Your {thing} is outdated. Refresh the page to get new changes. Remember you're going to loose your changes!",
        'WEB-CHROME': 'Web Chrome',
        'WEB-CHROME-DESCRIPTION':
          'Connects to pages shown in a Chrome browser. Can start Chrome if it isn\'t already running or create new tabs in a running Chrome if the desired page isn\'t already shown. Find the required Chrome extension <a href="https://chrome.google.com/webstore/detail/sirenia-chrome-driver/lbokehfhhclmidfioacglfeigplbccdj" target="_blank">here</a>.',
        'WEB-FF': 'Firefox',
        'WEB-FF-DESCRIPTION':
          'Connects to pages shown in a Firefox browser. Can start Firefox if it isn\'t already running or create new tabs in a running Firefox if the desired page isn\'t already shown. Find the required Firefox extension <a href="https://firefox.sirenia.io" target="_blank">here</a>.',
        HEADLESS: 'Headless',
        'HEADLESS-DESCRIPTION':
          'Does not connect to local applications or web pages. This type is suitable for flows that carry out tasks independently of locally running applications.',
        'WEB-IE': 'Web IE',
        'WEB-IE-DESCRIPTION':
          "Connects to pages shown in an Internet Explorer browser. Can start the browser if it isn't already running.",
        'WEB-IE-PROXY': 'Web IE (experimental)',
        'WEB-IE-PROXY-DESCRIPTION':
          'Experimental version of the Web IE type. Note: No longer supported. Please use Web IE type in stead - or another browser',
        'WEB-HIE': 'Web IE (built-in)',
        'WEB-HIE-DESCRIPTION':
          'Utilizes an Internet Explorer browser built into manatee. Useful for filling out web forms and other short lived web activities. Automates all pages it shows. This type will not connect to normal IE browsers or other running built-in browsers.',
        'WEB-HCHROME': 'Web Chrome (built-in)',
        'WEB-HCHROME-DESCRIPTION':
          'Utilizes a chrome browser built into manatee. Useful for filling out web forms and other short lived web activities. Automates all pages it shows. This type will not connect to normal chrome browsers or other running built-in browsers.',
        'WEB-EDGE': 'Web Edge',
        'WEB-EDGE-DESCRIPTION':
          'Connects to pages shown in an Edge browser. Can start Edge if it isn\'t already running or create new tabs in a running Edge if the desired page isn\'t already shown. Find the required Edge extension <a href="https://chrome.google.com/webstore/detail/sirenia-chrome-driver/lbokehfhhclmidfioacglfeigplbccdj" target="_blank">here</a>.',
        CONTEXTPARTICIPANT: 'Context Participant (CCOW)',
        'CONTEXTPARTICIPANT-DESCRIPTION':
          'Will connect to an existing CCOW compliate application using one of the supported protocols; JSON/HTTP, JSON-RPC/WS or PROTOBUF/GRPC. See <a href="https://docs.sirenia.io/manatee/v1.29/external-apis/overview/">this page</a> for developer info.',
        FLOW_DETAILS_HEADER: 'Flow details',
        OWNERSHIP_HEADER: 'Ownership',
        SHOW_SUGGESTIONBOX: 'Show suggestions',
        SHOW_HELP: 'Show help',
        HIDE_SUGGESTIONBOX: 'Hide suggestions',
        SHORTCUT: 'Shortcut | Shortcuts',
        SHOW_SHORTCUTS: 'Show shortcuts',
        HIDE_SHORTCUTS: 'Hide shortcuts',
        SHORTCUT_AUTOCOMPLETE: 'Autocomplete',
        SHOW_MINIMAP: 'Show minimap',
        SHORTCUT_BEAUTIFY: 'Autoformat code',
        SHORTCUT_BEAUTIFY_KEY: '⌃ B',
        SHORTCUT_START_SEARCHING: 'Start searching',
        SHORTCUT_FIND_NEXT: 'Find next',
        SHORTCUT_FIND_PREVIOUS: 'Find previous',
        SHORTCUT_REPLACE: 'Replace',
        SHORTCUT_REPLACE_ALL: 'Replace all',
        SHORTCUT_JUMP_TO_LINE: 'Jump to line',
        SHORTCUT_ADD_SELECTION: 'Add selection to next Find match',
        SHORTCUT_SHOW_COMMAND_PALETTE: 'Show Command Palette',
        SHORTCUT_RUN_FLOW: 'Run flow',
        SHORTCUT_DEBUG_FLOW: 'Debug flow',
        SERVER_ERROR: 'Internal server error',
        INPUT_AND_OUTPUT_HEADER: 'Inputs and outputs',
        TRIGGER_HEADER: 'Triggers',
        TRIGGER: 'trigger | triggers',
        TRIGGER_META: 'Choose a trigger to add',
        NONE: 'No {things}',
        CONTEXT_TRIGGER: 'Context-based trigger',
        CONTEXT_TRIGGER_CHANGE: 'Change',
        CONTEXT_META:
          'Change in "{subject}", from <span class="monospaced">{oldmatch}</span> to <span class="monospaced">{newmatch}</span>',
        LIFECYCLE: 'Lifecycle',
        GLOBAL_LIFECYCLE_EVENT: 'Global event | Global events',
        APP_LIFECYCLE_EVENT: 'App specific event | App specific events',
        URL: 'url',
        CURRENT_APPLICATION: 'Current application',
        FROM: 'From {thing}',
        TO: 'To {thing}',
        LIFECYCLE_TRIGGER: 'Lifecycle trigger',
        LIFECYCLE_META: 'When <i>{event}</i> happens',
        LIFECYCLE_NAVIGATED_META:
          'On navigation from <span class="monospaced">{fromUrl}</span> to <span class="monospaced">{toUrl}</span>',
        LIFECYCLE_EVENT: 'Event',
        LIFECYCLE_TRIGGER_ATTACHED: 'Attached',
        LIFECYCLE_TRIGGER_DETACHED: 'Detached',
        LIFECYCLE_TRIGGER_MANATEESTARTED: 'Manatee started',
        LIFECYCLE_TRIGGER_NAVIGATED: 'Navigated',
        EXTERNAL_TRIGGER: 'External trigger',
        ANCHOR_HEADER: 'Anchoring',
        ANCHOR: 'anchor | anchors',
        OLD: 'Old {thing}',
        CONTEXT_TRIGGER_VALUE: 'Value',
        POSITIONAL_FIELDS_USED: 'Your code contains fields: {fields}, which use positional anchors',
        POSITIONAL_FIELDS_USED_EX: 'If possible use fields without anchors: {positional}.',
        PROPERTY: 'Property',
        LAUNCHWITHARGUMENTS: 'Arguments',
        WINDOW: 'Windows',
        WINDOW_SHOWN: 'Shown',
        WINDOW_HIDDEN: 'Hidden',
        WINDOW_EVENT: 'Event',
        WINDOW_META: '{type} for window with title "{title}" and class "{class}"',
        HOTKEY: 'Hotkey',
        HOTKEY_META: 'Press {modifiers} and {keys} to trigger flow',
        WINDOW_TITLE: 'Title of window',
        WINDOW_CLASS: 'Class of window',
        CLOSE_WINDOW: 'Close window when discovered',
        HOTKEY_MODIFIER: 'Hotkey modifier key',
        HOTKEY_KEY: 'Hotkey key',
        INVALID_FILE: 'Uploaded file is invalid',
        INVALID_HOTKEY:
          'Invalid hotkey. It must contain at least one modifier key and one regular key.',
        TABLE: 'table | tables',
        TABLE_INSERT_ROW: 'Insert row',
        TABLE_DELETE_ROW: 'Delete row',
        TABLE_MOVE_CELL_LEFT: 'Move one cell left',
        TABLE_MOVE_CELL_RIGHT: 'Move one cell right',
        TABLE_MOVE_ROW_UP: 'Move one row up',
        TABLE_MOVE_ROW_DOWN: 'Move one row down',
        TABLE_SELECT_ROW: 'Select row',
        TABLE_META: 'Trigger flow when the selected table is updated',
        TABLE_VERY_LARGE_WARNING:
          'The table you have selected is *very large* this may cause a lot of network traffic if the table is updated often',
        DATA: 'Data',
        ROW: '{count} row | {count} rows',
        COLUMN: '{count} column | {count} columns',
        NO_ROWS: 'No rows in table',
        NO_MATCH_HEADER: 'No matches',
        NO_MATCH: 'No matches for "{term}"',
        DETAILS: 'Details',
        CRON: 'Cron',
        CRON_SECOND: 'Second',
        CRON_MINUTE: 'Minute',
        CRON_HOUR: 'Hour',
        CRON_DAYOFMONTH: 'Day of month',
        CRON_MONTH: 'Month',
        CRON_DAYOFWEEK: 'Day of week',
        CRON_HUMAN_DESC: 'The flow is scheduled to run:',
        CRON_NEXT: 'The flow will run next:',
        WORKINGDIRECTORY: 'Working directory',
        COMM_ERROR_HEADER: 'Communication error',
        COMM_ERROR_BODY: 'A communication error occurred. You have to login again.',
        FINDING_THE_FIELD: 'Means to locate field',
        IMAGE: 'Screenshot',
        IDENTIFIER: 'Identifier',
        NO_IMAGE: 'No screenshot',
        X_OFFSET: 'X offset',
        Y_OFFSET: 'Y offset',
        MATCH_CONFIDENCE: 'Match confidence',
        DETECT_FIELD: 'Detect field',
        GRAB_SCREENSHOT: 'Grab screenshot',
        CONNECTION_FAILED: 'Connection failed',
        NO_MANATEE_CONNECTION: 'Is manatee running? A connection could not be established{code}',
        MANATEE_CERTIFICATE_EXPIRED:
          'Manatee appears to use an expired certificate. Please notify an administrator',
        FIELD_FINDER_FAIL: 'Field finder problem',
        FIELD_FINDER_FAIL_INIT_MSG: 'Error message: {cause}',
        MISSING_APPLICATION: 'App not found',
        MISSING_APPLICATION_MESSAGE: 'Manatee sees no matching application',
        MODULE: 'Module',
        SERVICE: 'service | services',
        MAIL_SERVICE: 'Mail',
        MAIL_SERVICE_TRIGGER: 'Mail service',
        MAIL_SERVICE_TRIGGER_META: '',
        MAIL_SERVICE_TYPE: 'Mail service type',
        MAIL_SERVICE_TYPE_IMAPSMTP: 'IMAP',
        MAIL_SERVICE_TYPE_EXCHANGE: 'Exchange Server',
        EXCHANGE_SERVICE_URL: 'Exchange Web Service address',
        EXCHANGE_USERNAME: 'User name',
        EXCHANGE_PASSWORD: 'Password',
        EXCHANGE_USE_LEGACY_MODE: 'Legacy mode (before 2010 SP1)',
        FROM_ADDRESS: 'From',
        TO_ADDRESS: 'To',
        CC_ADDRESS: 'Cc',
        MAIL_SUBJECT: 'Subject',
        MAIL_BODY: 'Body',
        ATTACHMENTS: 'Attachments',
        SERVICE_NAME: 'Service name',
        SERVICE_NAME_PLACEHOLDER: 'Enter a name for the service',
        SERVICE_KEY: 'Service key',
        SERVICE_KEY_PLACEHOLDER: 'Enter a unique key for the service',
        IMAP: 'IMAP',
        IMAP_HOST: 'Hostname or IP',
        IMAP_HOST_PLACEHOLDER: 'Enter a hostname for the IMAP server',
        IMAP_PORT: 'Port',
        IMAP_PORT_PLACEHOLDER: 'Enter a port for the IMAP server',
        IMAP_USERNAME: 'Username',
        IMAP_USERNAME_PLACEHOLDER: 'Enter username for IMAP user',
        IMAP_PASSWORD: 'Password',
        IMAP_PASSWORD_PLACEHOLDER: '',
        SMTP: 'SMTP',
        SMTP_HOST: 'Hostname or IP',
        SMTP_HOST_PLACEHOLDER: 'Enter a hostname for the SMTP server',
        SMTP_PORT: 'Port',
        SMTP_PORT_PLACEHOLDER: 'Enter a port for the SMTP server',
        SMTP_USERNAME: 'Username',
        SMTP_USERNAME_PLACEHOLDER: 'Enter username for SMTP user',
        SMTP_PASSWORD: 'Password',
        SMTP_PASSWORD_PLACEHOLDER: '',
        SERVICE_NOT_USED: 'Service not used',
        TITLE_TYPE_NAME: '{type} > {name}',
        TITLE_TYPE: '{type}',
        FILESYSTEM: 'Filesystem',
        FILESYSTEM_META:
          'Triggers for files in <span class="monospaced">{directory}</span> matching "{match}"',
        FILESYSTEM_DIRECTORY: 'Directory',
        FILESYSTEM_MATCH: 'Match',
        KEYBOARD: 'Keyboard',
        KEYBOARD_META_DEBOUNCE:
          'When keyboard input entered with no pauses exceeding {debounceMs}ms matches {match}',
        KEYBOARD_META_LOOKBACK: 'When keyboard input entered within {lookbackMs}ms matches {match}',
        KEYBOARD_DEBOUNCEMS: 'Input with pauses under (ms)',
        KEYBOARD_LOOKBACKMS: 'Entire input within (ms)',
        KEYBOARD_MATCH: 'Match',
        KEYBOARD_MATCH_DEBOUNCE_MODE: 'Inter-key pause - delayed',
        KEYBOARD_MATCH_LOOKBACK_MODE: 'Time window - immediate',
        KEYBOARD_MATCH_MODE: 'Mode',
        KEYBOARD_MATCH_PLACEHOLDER: 'Input match pattern',
        MATCH_ON_DESKTOP: 'Match the image on complete desktop',
        MANDATORY_STATE: 'Is state mandatory for application?',
        SUGGESTION: '{type}',
        PRECOMPILE_FLOW: 'Pre-compile flow',
        WEBSOCKET_HOST: 'Host',
        WEBSOCKET_PORT: 'Port',
        WEBSOCKET_SECURE: 'Encrypted',
        INTERCEPT_EVENT: 'Intercept event',
        INTERCEPT_META: 'When the "{eventType}" event is intercepted on "{fieldName}".',
        INTERCEPT_EVENTTYPE: 'Type of event',
        INTERCEPT_LEFTCLICK: 'Click with left mouse-button',
        INTERCEPT_RIGHTCLICK: 'Click with right mouse-button',
        INTERCEPT_NO_FIELD: 'Please specify a field',
        INTERCEPT_NO_EVENTTYPE: 'Please specify the type of event',
        TRIGGER_ENABLED: 'Enabled',
        PATH_TOKENS_NOT_UNIQUE: 'Not unique',
        JVMLOCATION: 'JVM location',
        FULLNAME: 'Full name',
        VALIDATIONERRORS: 'Validation errors',
        MISSINGUSERNAME: 'Missing a username',
        PASSWORDTOOSIMPLE: 'Password is too simple',
        PASSWORDSUGGESTIONS: 'Suggestions to improve your password',
        USER_IS_ADMIN: 'Super-user',
        REPEATPASSWORD: 'Repeat password',
        CREATEUSERWITHPASSWORD_HELP:
          'If you specify a password here the user will be able to login and edit flows etc using this password. By making the user into a super-user s/he will be able to create new users as well as make other users super-users as well.',
        RESETUSERPASSWORD_HELP: 'Type in a new password to reset your password here.',
        PASSWORD_OK: 'Your password has my approval.',
        DISABLE_KNOWN_EXECUTABLE: 'Disable automatic detection of executable',
        AUTOCOMPLETION: 'Autocompletion',
        SNIPPET: 'snippet | snippets',
        USE_SNIPPETS: 'Use snippets when autocompleting',
        USE_TYPES: 'Use typesystem when autocompleting',
        COMPATIBLE_WITH: 'Compatible with Manatee in version',
        RUNTIME_PROPERTIES: 'Runtime properties',
        SWITCH: 'Switch {thing}',
        EDITORSETTINGS: 'Editor settings',
        TOO_MANY_MATCHES: 'Too many results ({omitted} omitted)',
        TOO_MANY_FLOWS_TO_SHOW: 'Too many flows to show',
        PREFERENCES: 'Your preferences',
        PREFERENCES_CATEGORIES: 'Categories',
        PREFERENCES_EDITOR: 'Flow editor',
        PREFERENCES_MISC: 'Miscellaneous',
        ENABLE_AUTO_SAVE: 'Save automatically',
        ENABLE_AUTO_APP_GROUP: 'Add group to app when adding to flow',
        RESET_TO_DEFAULTS: 'Reset to defaults',
        RESET_TO_DEFAULTS_CONFIRM_MESSAGE: 'Reset {thing} to defaults?',
        RESTORE_FOCUS_AFTER_FLOW: 'Restore focus to currently focused window after flow',
        MOVE: 'Move {thing} {direction}',
        DIRECTION_UP: 'up',
        DIRECTION_DOWN: 'down',
        DIRECTION_LEFT: 'left',
        DIRECTION_RIGHT: 'right',
        NEXT_PAGE: 'Next page',
        PREV_PAGE: 'Previous page',
        LAST_PAGE: 'Last page',
        MENU_SIRENIA_EXTENSION: 'Extension',
        FIRST_PAGE: 'First page',
        INTERCEPT_ALLOWOUTSIDEWINDOW: 'Allow trigger outside window',
        INTERCEPT_ALLOWUNFOCUSED: 'Allow trigger when app is unfocused',
        ESTERO: 'Conductor',
        MANATEE: 'manatee | manatees',
        MANATEE_VERSION: 'Manatee version',
        ESTERO_SIMPLE: 'Simple query',
        ESTERO_SIMPLE_LABEL: 'Setup a filter for Manatees here',
        ESTERO_SIMPLE_HELP_LINK: 'https://docs.sirenia.io/cuesta/v1.15/#mql',
        ESTERO_ADVANCED_EDITOR_LABEL: 'Enter an MQL query to filter below',
        ESTERO_ADVANCED_EDITOR_HELP_LINK:
          'https://docs.sirenia.io/cuesta/v1.15/#filtering-manatees',
        ESTERO_ADVANCED: 'Advanced query',
        SHOW_CONTROLS: 'Show controls',
        ESTERO_VIEWCODE: 'Query code',
        SAVED_VIEW: 'saved view | saved views',
        MACHINENAME: 'Machine name',
        USERDOMAIN: 'Domain',
        PRODGROUP: 'Primary group',
        RUNNING_FLOW: 'Running flow',
        NO_RUNNING_FLOW: 'Idling',
        MANATEE_COUNT: '{count} Manatee | {count} Manatees',
        MANATEE_UPTIME: 'Uptime',
        KITCHENTABLE_ITEMCOUNT: '{count} row | {count} rows',
        KITCHENTABLE_PAGE: 'Page {current} of {total} ({perPage} per page)',
        KITCHENTABLE_EMPTY: 'Nothing to show here',
        ESTERO_DETAILS: 'Details for Manatee {id}',
        ESTERO_COL_DETAILS: ' ',
        ESTERO_RUN_FLOW: 'run flow',
        ESTERO_RESET_SETTINGS: 'reset settings',
        ESTERO_SAVE_SETTINGS: 'save setting | save {count} settings',
        ESTERO_RESET_SETTINGS_CHANGES: 'undo changes',
        ESTERO_RESTART: 'restart',
        ESTERO_SHUTDOWN: 'shutdown',
        ESTERO_CONFIRM: 'Are you sure you want to {action}?',
        SEARCH_OPERATOR_EQUALS: 'equals',
        SEARCH_OPERATOR_NOT_EQUALS: 'does not equal',
        SEARCH_OPERATOR_LESS_THAN: 'is less than',
        SEARCH_OPERATOR_LESS_THAN_OR_EQUALS: 'is less than or equals',
        SEARCH_OPERATOR_GREATER_THAN: 'is greater than',
        SEARCH_OPERATOR_GREATER_THAN_OR_EQUALS: 'is greater than or equals',
        SEARCH_OPERATOR_STARTS_WITH: 'starts with',
        SEARCH_OPERATOR_ENDS_WITH: 'ends with',
        SEARCH_OPERATOR_CONTAINS: 'contains',
        SEARCH_OPERATOR_CONTAINS_NOT: 'does not contain',
        SEARCH_OPERATOR_MATCHES_REGEXP: 'matches regular expression',
        ESTERO_SIMPLE_MENU_PROP: 'Select property',
        ESTERO_SIMPLE_MENU_OPERATOR: 'Select operator',
        ESTERO_SIMPLE_MENU_VALUE: 'Enter value to compare',
        ESTERO_FIND_FLOW: 'Find flow',
        ESTERO_SPECIFY_INPUTS: 'Specify inputs',
        ESTERO_CONNECTION_LOST_HEADER: 'Lost connection',
        ESTERO_CONNECTION_LOST_BODY: 'Connection to the Conductor was lost',
        ESTERO_FLOW_RESULTS: 'Flow results',
        ESTERO_FLOW_NO_RESULTS: 'Flow done',
        ESTERO_FLOW_ERROR: 'Flow run failed with {err}',
        MANATEE_BRANCH: 'Branch',
        ESTERO_FAIL: 'Failed to execute {action}',
        ESTERO_SUCCESS: '{action} succeeded',
        RUN: 'Run',
        YES: 'Yes',
        NO: 'No',
        OK: 'Ok',
        CANCEL: 'Cancel',
        THEME: 'Visual theme',
        THEME_BROWSER: 'Browser theme',
        THEME_LIGHT: 'Light theme',
        THEME_DARK: 'Dark theme',
        SETTING: 'setting | settings',
        SETTING_TARGET_HEADER: 'Select primary group and version to target',
        SETTING_HEADER: 'Add settings to override',
        SETTING_VALUE: 'Setting value',
        SETTING_KEY: 'Setting key',
        SETTING_INVALID_VALUE: 'The value for this setting is not valid. {instruction}',
        SETTING_INVALID_INSTRUCTIONS_URL: 'It must be a valid url.',
        SETTING_INVALID_INSTRUCTIONS_REGEXP: 'It must match the regular expression "{regexp}".',
        SETTING_NOT_SUPPORTED_IN_VERSION: 'This setting is not supported in the selected version',
        SETTING_GROUP_VERSION_NOT_UNIQUE: 'Group and version must be unique for settings.',
        SETTING_INVALID_TYPED: 'It must have type {type}.',
        ACCESS_DENIED: 'You cannot access {location}. Contact an administrator for details.',
        ERROR_CONFLICTING_FLOW: 'This flow already exists',
        ERROR_CONFLICTING_FLOW_SAME_APP:
          'The name or subject conflicts with existing flow {conflictingFlow}',
        WARN_CONFLICTING_FLOW_OTHER_APP:
          'A conflicting flow with name {conflictingFlow} already exists in app {conflictingApp}. Are you sure you want to proceed?',
        EXACT_MATCH: 'exactly matches {thing}',
        REFERENCES: 'references {thing}',
        SIZE: 'size',
        FILTER_FLOWS_PROPERTY: 'What to match',
        FILTER_FLOWS_OPERATOR: 'How to match',
        POPUP_HANDLING: 'Popup window behaviour',
        OPEN_POPUP: 'Open new popups in {in}',
        POPUP_HELP_IN_BROWSER:
          'This will open new popups in external browser windows. These windows can be automated by seperate apps and will not close when the origin window closes.',
        POPUP_HELP_IN_INTERNALWINDOW:
          'This will open new popups in new embedded windows. They cannot be automated and will be closed once the original app closes.',
        FILTER_FLOWS_VALUE: 'Value to match',
        STATE_SUBJECT: 'Subject of state',
        HAS: 'Has {thing}',
        COUNT: 'Number of {thing}',
        SEARCH_OPERATOR_IS_TRUE: 'Is true',
        SEARCH_OPERATOR_IS_FALSE: 'Is false',
        BROWSER: 'browser',
        INTERNAL_WINDOW: 'an embedded window',
        DETACH_SECTION: 'Detach options',
        WINDOW_BEHAVIOR_ON_DETACH: 'Window behaviour on detach',
        CLOSE_WINDOW_ON_DETACH: 'Close it on detach',
        LET_WINDOW_REMAIN_OPEN_ON_DETACH: 'Let window remain open',
        USE_GLOBAL_SETTING: 'Use the global setting',
        CHOOSE_COLUMNS: 'Choose columns',
        WARN_SAVE_WITH_ERRORS: 'Saving with error',
        WARN_COLUMN_NOT_SORTABLE: 'Column "{column}" cannot be sorted',
        LOCALIZATION: 'Localization',
        I18N_CUESTA: 'Cuesta',
        I18N_MANATEE_STRINGS: 'Manatee (strings)',
        I18N_MANATEE_RESOURCES: 'Manatee (resources)',
        HUB: 'hub | hubs',
        FLOW_IS_DOWNLOADED: 'Flow is downloaded from a hub in version {version}',
        TOKEN: 'token',
        PUBLICATIONS_FROM: 'All publications from this registry to {hub}.',
        PUBLICATION_TYPE: 'publication type',
        PUBLICATION_NAME: 'name',
        PUBLICATION_APP: 'publication app',
        LICENSE: 'license | licenses',
        CATEGORY: 'category | categories',
        PUBLICATION_VERSION: 'version',
        PUBLICATION: 'publication | publications',
        ABSTRACT: 'Short description',
        RELEASENOTE: 'release note',
        PUBLISH_NEW: 'Publish new version',
        CHANGES_SINCE: '{count} changes since last publication',
        NOT_PUBLISHED: 'This {thing} has not been published',
        LAST_MODIFIED: 'last modified',
        FILENAME: 'Filename',
        EDIT_PUBLICATION_HEADER:
          'You can now edit the details of the publication and click save to store these. This will not create a new version.',
        PUBLISH_NEW_HEADER:
          'Publish an initial or an updated version of this flow to a the {hub} hub.',
        NAME_OF: 'Name of {thing}',
        DESCRIPTION_OF: 'Description of {thing}',
        LICENSE_TEMPLATE: 'license template',
        NO_ATTACHMENTS: 'No attachments. Drag files here to attach.',
        PUBLICATION_TYPE_FLOW_NAME: 'Single flow',
        PUBLICATION_TYPE_FLOW_DESC:
          '<p>A single flow is published as is without any kind of pre-processing. After downloading the flow, users are able to <b>see</b> and <b>edit</b> the code  of the flow.</p><p>Updates to the publication will overwrite any local changes when the flow is updated from the hub. Use this type if the flow is meant as an inspiration and if the flow is self-contained, i.e. does not include references to fields, other flows etc.</p>',
        PUBLICATION_TYPE_INLINED_FLOW_NAME: 'Inlined flow',
        PUBLICATION_TYPE_INLINED_FLOW_DESC:
          '<p>An inlined publication of a flow involves pre-processing the flow s.t. any fields and other flows referenced are included in the publication.</p><p>Users cannot see the code of an inlined publication making applying updates to the flow easy and painless. Use this publication if you need to publish something that can be tailored via extensions when downloaded.</p>',
        MARKDOWN_EDITOR_HELP: 'You can use markdown to format the content of this field.',
        DROP_HERE_TO_ATTACH: 'Drop files here to attach them to the publication of the flow',
        SAVE: 'save',
        GET: 'Get {thing}',
        HUB_SEARCH_AND_GET_HEADER: 'Update existing or get new flows from a hub',
        HUB_SEARCH_AND_GET_BODY:
          'Find the flow to get or update by using the controls below. You can see all flows from all configured hubs here.',
        ALREADY_NEWEST: 'The downloaded flow is the most recent version.',
        GOTO: 'Go to "{destination}".',
        UPDATE_VERSION_ON_RELEASE_NOTE:
          'The release-note version must be changed to publish a new version.',
        MISSING_NAME: 'You need to provide a name.',
        HAS_UPDATE:
          'A new version of has been published. You can update to the latest version here.',
        HAS_LOCAL_CHANGES:
          'The flow has local changes. You can update, but it will overwrite any local changes you have made.',
        OVERWRITE_LOCAL_CHANGES_HEADER: 'Overwrite local changes?',
        OVERWRITE_LOCAL_CHANGES_BODY:
          'Are you sure you want to overwrite local changes made to the flow with the newest published version?',
        WAS_INSTALLED: '{thing} was installed',
        WAS_NOT_INSTALLED: '{thing} was not installed',
        WAS_PUBLISHED: '{thing} was published',
        WAS_NOT_PUBLISHED: '{thing} was not published',
        WAS_NOT_DELETED: '{thing} was not deleted',
        CHOOSE_APP_FOR_INSTALL: 'Choose which app to install the flow "{name}" in',
        ALREADY_INSTALLED:
          'The flow "{name}" is already installed. You can only install one instance of a flow. See in which application below.',
        NO_SUCH: 'No such {thing} could be found.',
        INL_FIELD_NAME_IS_NO_LITERAL:
          'Field name must be known at compile time. Seen at "{flowName}".',
        INL_NO_SUCH_FIELD: 'No field called "{name}" in "{flowName}".',
        INL_FIELD_HAS_ALTERNATIVES:
          'We cannot inline fields that have alternatives in "{flowName}".',
        INL_NO_NAME_FOR_FLOW: 'Flow is missing a name. In "{flowName}".',
        INL_FLOW_NAME_IS_NO_LITERAL: 'Flow name must be known at compile time in "{flowName}".',
        INL_NO_SUCH_FLOW: 'No flow called "{name}" in "{flowName}".',
        INL_NO_SUCH_FLOW_ON_APP: 'No flow called "{name}" in this app in "{flowName}".',
        INL_SERVICE_CANNOT_BE_INLINED: 'We cannot inline services. Seen in "{flowName}".',
        INLINE_ERROR_HEADER: 'Inline error',
        INLINE_ERROR_MESSAGE_FALLBACK: 'Running flow as is: {error}',
        CONNECT_TO: 'Connect to {thing}',
        ERR_LOADING_FROM_HUB: 'Failed to load from hub: {err}',
        ENVIRONMENT: 'Environment',
        HOME_HEADER: 'Welcome to {productName}',
        HOME_BODY:
          'Use {productName} to code automations for Manatee and configure when, where and for whom they are run.',
        NO_LANDING_PAGE_CONFIGURATION_HEADER:
          'You have not configured this part of the landing page yet',
        NO_LANDING_PAGE_CONFIGURATION_BODY:
          'Go to the <a href="#/configuration/preferences">user preferences page</a> to configure what should be displayed here. One option is "last edits" which will show a list of the last flows, apps, tables or fields you have edited.',
        NO_SAVED_SEARCHES:
          'There are no saved searches. Go to the <a href="#/flows">flows page</a> to configure and save lists to use here.',
        SAVED_SEARCH: 'saved search | saved searches',
        ENTRY: 'entry | entries',
        PREFERENCES_LANDING_PAGE: 'Landing page',
        PREFERENCE_LP_HEADER: 'Configure what to display on the landing page',
        PREFERENCE_LP_BODY:
          'You can configure 3 elements shown below the search field on the landing page.',
        LAST_EDITS: 'Last edited',
        NOTHING_EDITED:
          'There is no information about your last edits. Try editing a flow, app, field or table and return here.',
        PREFERENCES_SECURITY: 'Security',
        '2FA_PREFERENCE_DESCRIPTION':
          'Enable 2-factor authentication. You are required to have an app that can generate TOTP codes, e.g. Google Authenticator or 1Password.',
        '2FA_ENABLED': '2-factor authentication',
        PREFERENCES_PROFILE_PICTURE: 'Profile Picture',
        PROFILE_PICTURE_DESCRIPTION:
          'Cuesta will automatically use any image uploaded to the gravatar.com profile with your email. Upload a picture here to use instead.',
        PROFILE_PICTURE_RESET: 'reset',
        PROFILE_PICTURE_UPLOAD: 'upload',
        PROFILE_PICTURE_SIZE_EXCEED: 'Image size exceeded',
        PROFILE_PICTURE_TYPE_ERROR: 'Please select a valid image type',
        PROFILE_ICON_TITLE: 'Profile picture',
        ENABLE_2FA_HEADER: '2-factor authentication',
        ENABLE_2FA_QR:
          'Scan the QR code with your preferred TOTP app, then enter the code it gives you below.',
        ENABLE_2FA_SECRET_HEADER: 'Secret',
        ENABLE_2FA_SECRET_BODY: '... or enter the secret manually into your app if applicable.',
        ENABLE_2FA_TOTP_HEADER: 'One-time passcode',
        ENABLE_2FA_TOTP_BODY:
          'Enter the one-time passcode generated by your authenticator app here to enable 2-factor authentication.',
        TOTP: 'One-time passcode',
        '2FA_RECOVERY_CODES':
          'Copy and save these recovery-codes in case you lose access to your authenticator app.',
        '2FA_VERIFY_CODE': 'Verify code',
        '2FA_ENTER_RECOVERY_CODE':
          'Click this button to switch between one-time passcode and recovery-code.',
        RECOVERY_CODE: 'Recovery code',
        '2FA_ENABLE_AND_VERIFY_CODE': 'Enable and login',
        '2FA_RECOVERY_CODES_PROCEED': 'Proceed',
        LOOKING_FOR: 'Looking for {thing}. Found in {found}.',
        USES_OF: 'uses of "{thing}"',
        LOCATION_COUNT: 'no locations | one location | {count} locations',
        RESTRICTION: 'restriction | restrictions',
        RESTRICTION_WARNING:
          'There is a restriction on the use of {module}.{method} for the version and groups that are on this flow. Manatee will perform the following actions when encountering this line; {actions}.',
        RESTRICTION_ACTION_KIND_DENY: 'Deny (stops the flow)',
        RESTRICTION_ACTION_KIND_PARAM: 'Check parameters',
        RESTRICTION_ACTION_KIND_PROMPT: 'Prompt the user',
        RESTRICTION_ACTION_KIND_LOG: 'Log the usage and continue',
        RESTRICTION_PROMPT_DESCRIPTION: 'The message that the user will be prompted with',
        RESTRICTION_TIMEOUT_DESCRIPTION: 'Timeout for the message prompt',
        RESTRICTION_LOG_MESSAGE: 'The message to log',
        RESTRICTION_TARGET_HEADER: 'Group and version to restrict',
        RESTRICTION_HEADER: 'Restrictions',
        METHOD: 'method',
        PROMPT_LABEL: 'Prompt user',
        PARAM_LABEL: 'Param check',
        LOG_LABEL: 'Log and continue',
        DENY_LABEL: 'Deny (abort)',
        RESTRICTION_GROUP_VERSION_NOT_UNIQUE:
          'Group and version must be unique on a restriction set',
        SHOW: 'Show {thing}',
        EXTENSION: 'extension | extensions',
        EXTENSIONS_DESCRIPTION:
          'The following extensions are defined in the flow. When you publish then the user downloading the inlined flow will need to map these to concrete versions to use the flow.',
        EXTENSION_STRING_DESCRIPTION:
          'Supplied string must match regex <b class="monospaced">{match}</b>.',
        EXTENSIONS_INPUT_DESCRIPTION:
          'The following extensions can be used to customize the flow with local options.',
        EXTENSION_SELECTION_DESCRIPTION: 'Available options are; {options}',
        EXTENSION_CODE_DESCRIPTION: '',
        EXTENSION_FIELD_DESCRIPTION: '',
        EXTENSION_FLOW_DESCRIPTION: '',
        EXTENSION_HEADER: 'Extension <emph>{name}</empty> providing a {type}',
        EXTENSION_FIELD_INPUT_FOR: 'Select a field for {name}',
        EXTENSION_FLOW_INPUT_FOR: 'Select a flow taking {inputs}',
        EXTENSION_SELECTION_INPUT_FOR: 'Select an item for {name}',
        EXTENSION_STRING_INPUT_FOR: 'Provide a string for {name}',
        EXTENSION_TABLE_INPUT_FOR: 'Choose a table for {name}',
        INPUTS: '{list} as input',
        NO_INPUTS: 'no inputs',
        CACHE_HEADER: 'Cuesta cache',
        CACHE_FLUSH_BUTTON_TEXT: 'Clear cache now',
        JOBS: 'jobs',
        ANALYZE_CODE: 'analyze code',
        PREPARE_CACHE: 'prepare cache',
        READ_MANY_FROM_CACHE: 'read {typename} from cache',
        APPLICATION_TYPE: 'app type | app types',
        MANATEE_SETTINGS: 'manatee settings',
        READ_CHANGED_FROM_SERVER: 'read changed {typename} from server',
        APPLY_DELTAS: 'update cached {typename}',
        GET_BY_ID: 'get {typename} by id',
        GET_BY_NAME: 'load {typename} {name}',
        GET_FOR_APP: 'get {typename} for app',
        GET_FOR_MAINTAINER: 'get {typename} for maintainer',
        SAVE_TYPE: 'save {typename}',
        CREATE_TYPE: 'create {typename}',
        DELETE_TYPE: 'delete {typename}',
        MATCHES_EXACT_MD: 'matches exactly `{value}`.',
        MATCHES_REGEX_MD: 'matches the regular expression `{value}`.',
        MATCHES_WILDCARD_MD: 'matches any value in the current level',
        MATCHES_DEEPWILD_MD: 'matches any value in any levels (keep searching the tree)',
        MATCHES_CONTAINS_MD: 'matches where `{value}` is contained in the property.',
        MATCHES_ENDSWITH_MD: 'matches where `{value}` is a suffix of the property.',
        MATCHES_STARTSWITH_MD: 'matches where `{value}` is a prefix of the property.',
        MATCHES_WINDOW_MD: 'matches the window containing `{value}` in its title ',
        MATCHES_GLOBAL_MD: 'in any windows on the desktop.',
        MATCHES_LOCAL_MD: 'in any child windows of the current window.',
        RELATION_ABOVE_MD: 'this element will be used to find another element *below* which',
        RELATION_BELOW_MD: 'this element will be used to find another element *above* which',
        RELATION_LEFT_MD:
          'this element will be used to find another element *to the right of* which',
        RELATION_RIGHT_MD:
          'this element will be used to find another element *to the left of* which',
        RELATION_NEAREST_MD: 'this element will be used to find another element *near* which',
        RELATION_SIBLING_MD: 'this element will be used to find a *sibling* element which',
        RELATION_CHILD_MD: 'this element will be used to find a *child* element which',
        ONLYVISIBLE_MD: 'only visible elements are searched.',
        HINT_MD: 'only properties matching the hint `{value}` will be considered.',
        NO_HINT_MD: 'all properties will be considered.',
        INDEX_MD: 'match number `{value}` will be chosen.',
        TOKEN_TARGET_HEADER: 'Actual target',
        MATCH_HINT_MENU_HEADER: 'Property to match',
        MATCH_HINT_ALL: 'All properties',
        MATCH_HINT_TEXT: 'Match any textual content',
        MATCH_HINT_ID: 'Match the id',
        MATCH_HINT_TYPE: 'Match the control type',
        MATCH_HINT_CLASS: 'Match the control class',
        MATCH_HINT_NAME: 'Match the control name',
        MATCH_HINT_LEGACYVALUE: 'Match the legacy value',
        MATCH_TYPE_MENU_HEADER: 'How to match',
        MATCH_TYPE_EXACT: 'Exactly',
        MATCH_TYPE_REGEX: 'Regular expression',
        MATCH_TYPE_STARTSWITH: 'A prefix',
        MATCH_TYPE_ENDSWITH: 'A suffix',
        MATCH_TYPE_CONTAINS: 'Contains',
        MATCH_TYPE_WILDCARD: 'Match anything',
        MATCH_TYPE_DEEPWILD: 'Match anything recursively',
        MATCH_TEXT: 'Value to match',
        MATCH_INDEX: 'Index',
        TOKEN_RELATION_ADD: 'Add an intermediate step',
        TOKEN_REF_HEADER: 'Reference target',
        TOKEN_RELATION_HEADER: 'Reference/target relation',
        CHILD_OF_TITLE: 'Target must be parent to the reference control.',
        SIBLING_OF_TITLE: 'Target must be sibling to the reference control.',
        'LEFT-OF_TITLE': 'Target can be found to the right of the reference control.',
        'RIGHT-OF_TITLE': 'Target can be found to the left of the reference control.',
        ABOVE_TITLE: 'Target can be found below the reference control.',
        BELOW_TITLE: 'Target can be found above the reference control.',
        NEAREST_TITLE: 'Target is the nearest match to the reference control.',
        RELATION: 'relation | relations',
        MATCH_WINDOW_REGEX: 'Regex for title match',
        TOKEN_WINDOW_GLOBAL: 'Try all windows on desktop',
        TOKEN_INCLUDE_INVISIBLE: 'Include invisible controls',
        RIGHT_CLICK_TO_EDIT: 'Right click to show edit menu for token.',
        FIELD_PATH_SETTINGS: 'Settings',
        HIGHLIGHT: 'Highlight.',
        USE_AS_FIELD_PATH: 'Use as field path.',
        FIELD_TREE: 'Tree',
        PROPERTIES_OF: 'Properties of {thing}',
        FIELD_TREE_EXPAND_ALL: 'Expand all',
        FIELD_SEARCH: 'Search in tree',
        FIELD_TREE_NONE_HTML:
          'There is no information about the structure of the UI for this application. Press the <span class="ui mini green icon button"><i class="refresh icon"></i></span> button above to reconstruct it from the <i>live</i> application.',
        CHOOSE: 'Choose {thing}',
        FLOW_CANNOT_DELETE_LAUNCH_HELP:
          'Cannot delete flow since it is the designated launch flow.',
        CHAT_SERVICE: 'Chat',
        CHAT_SERVICE_TYPE: 'Type',
        CHAT_SERVICE_TYPE_SLACK: 'Slack',
        SLACK: 'Slack settings',
        SLACK_APP_TOKEN: 'App token',
        SLACK_APP_TOKEN_PLACEHOLDER: 'Enter slack app token here',
        SLACK_APP_TOKEN_HELP:
          'The app token is used to listen for new messages when the service is used as a trigger. You must have the <code>connections:write</code> scope on your token for this to work.',
        SLACK_BOT_USER_TOKEN: 'Bot user token',
        SLACK_BOT_USER_TOKEN_PLACEHOLDER: 'Enter slack bot user token here',
        SLACK_BOT_USER_TOKEN_HELP:
          'The bot user token is used to read/write message from Manatee back into slack. You must have the following scopes on the bot token:<p><ul><li><code>channels:read</code></li><li><code>channels:history</li><li><code>chat:write</code></li><li><code>users:read</code></li><li><code>im:read</code></li><li><code>npim:read</code></li></ul></p>',
        CHAT_SERVICE_TRIGGER: 'Chat',
        CHAT_SERVICE_TRIGGER_META:
          'Trigger flows when messages matching the below specified criteria are received.',
        CHAT_CHANNEL: 'Channel',
        CHAT_FROM: 'From',
        CHAT_MESSAGE: 'Message',
        ALERT_RULE: 'alert rule | alert rules',
        ALERT_RULE_NAME: 'Name',
        ALERT_RULE_ENABLED: 'Enabled',
        ALERT_RULE_CONDITION: 'alert condition | alert conditions',
        ALERT_RULE_INTERVAL: 'Interval',
        EVERY: 'every',
        MINUTE: 'minute | minutes',
        ALERT_RULE_HITS: 'Hits',
        REQUIRE: 'require',
        HITS_TO_ACT: 'hit to act | hits to act',
        ALERT_RULE_CONDITION_QUERY: 'Query',
        ALERT_RULE_QUERY_CONDITION_LABEL: 'Trigger when the following query is true',
        ALERT_RULE_CONDITION_FLOW: 'Flow',
        ALERT_RULE_FLOW_LAUNCH_HELP:
          'Choose a flow to launch. This flow will decide whether the alert rule is triggered or not. If you return no values from the flow, the alert rule <b>will not</b> be triggered. If you return any value the alert will be triggered.',
        ALERT_RULE_ACTION: 'alert action | alert actions',
        ALERT_ACTION_TYPE_MAIL: 'Email',
        ALERT_ACTION_TYPE_CHAT: 'Chat',
        EMAIL_BODY: 'Body',
        EMAIL_SUBJECT: 'Subject',
        ALERT_TARGETS: 'Alert targets <b>{user}</b> at <b>{machine}</b> only.',
        ALERT: 'alert | alerts',
        ALERT_RULE_TARGET: 'Target for alert',
        MACHINE: 'machine | machines',
        ALERT_LAST_INACTIVE: 'Alert was last green at {time}',
        ALERT_IS_ACTIVE: 'Alert is active',
        ESTERO_ALERT: 'Alert',
        ESTERO_ALERT_LOG: 'Alert log',
        NOW: 'just now',
        ALERT_MESSAGE_INTERPOLATION:
          'The message from e.g. the flow executed to trigger the alert.',
        ALERT_RULE_CONDITION_DESC:
          'The condition that must be met to trigger the alert. This can either be a query/predicate or the result of running a flow.',
        ALERT_RULE_ACTIONS_DESC:
          'The actions to take when a condition is met. The action will run when the alert switches from inactive to active.',
        GROUP_INCLUDED_IN_GROUP_DESCRIPTION:
          'A list of groups that <b>this group</b> is included in.'
      }
    },
    typename: 'locale'
  },
  {
    item: {
      name: 'da',
      descriptive: {
        PRODUCT_NAME: '',
        PRODUCT_LOGO:
          'data:image/svg+xml;base64,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',
        ACTION: 'Handling | Handlinger',
        ACTION_CLICK: 'Klik',
        ACTION_FOCUS: 'Fokuser',
        ACTION_INPUT: 'Input',
        ACTION_READ: 'Læs',
        ADD: 'Tilføj {thing}',
        ADD_ITEM_CONFIRM: 'Er du sikker på, at du vil tilføje elementet {thing}?',
        ALL_REQUIRED_FIELDS: 'alle obligatoriske felter',
        ALLOW_CAMERA_MICROPHONE: 'Tillad kamera/mikrofon',
        ANALYTICS: 'Analytics',
        ANNOTATION: 'Annotation',
        APPLICATION: 'app | apps',
        APPLICATION_ALREADY_EXISTS_WARN:
          'Applikationen eksisterer allerede. Hvis du fortsætter risikerer du at overskrive data.',
        AUTHENTICATE: 'Log ind',
        AUTHENTICATE_TIP: 'Verificer venligst dit brugernavn og password',
        BASIC_SETUP: 'Indstillinger',
        BEAUTIFY_CODE: 'Auto-formater kode',
        BLACKBOX: 'Blackbox',
        BLOCKLY: 'blokke',
        BLOCKLY_CHANGE_WARN:
          'Direkte kodeændringer detekteret. Fortsæt og fjern det nu forældede blokdiagram?',
        BLOCKLY_EMPTY_HEADER: 'Der er endnu ingen blokke i dette flow',
        BLOCKLY_EMPTY_MESSAGE:
          'Du kan generere blokke svarene til flowets kode ved at klikke på knappen. Du kan vende tilbage til direkte koderedigering når som helst. Dette vil fjerne blokdiagrammet.',
        BLOCKLY_EMPTY_WARN:
          'Bemærk at flowets nuværende kode vil blive erstattet med kode genereret ud fra blokkene første gang du interagerer med dem. Brug historik-visningen til at rulle tilbage, hvis den genererede kode ikke falder i din smag.',
        BLOCKLY_GENERATE_BUTTON: 'Generer blokke',
        BLOCKLY_GENERATE_MEDIUM_CODE_MSG:
          'Bemærk at blok kodning virker bedst for små flows. Ønsker du at fortsætte?',
        BLOCKLY_GENERATE_LARGE_CODE_MSG:
          'BEMÆRK: Dit flow er blevet ret stort. Blok kodning vil ikke være produktivt for så stort et flow. Ønsker du at fortsætte?',
        BLOCKLY_BAD_XML_HEADER: 'Blok diagrammet er ugyldigt',
        BLOCKLY_BAD_XML_MESSAGE:
          'Inkluder venligst flow-koden og følgende fejlbesked, når du rapporterer fejlen:',
        SINCE: 'Siden',
        FAILED_CHANGE_TAG: 'Kunne ikke ændre taggen. Taggen skal være unikke og ikke-tomme',
        FAILED_REMOVE_TAG: 'Kunne ikke fjernes taggen',
        TAG_CHANGED: 'Tag ændret',
        TAG_REMOVED: 'Tag fjernet',
        CHANGELOG: 'Changelog',
        CHANGES_SELECT: 'Vælg ændringer for at sammenligne',
        CLEAR_CONSOLE: 'Ryd konsol',
        CODE_EDITOR_MENU_SEARCH_HELP: 'Søg for at finde kodestumper',
        CODE_EDITOR_MENU_SEARCH_NO_RESULTS: 'Ingen fundet',
        CODE_EDITOR_MENU_OVERFLOW_MESSAGE:
          'For mange resultater. Begræns søgningen yderligere for at se alle resultater',
        CONSOLE_OUTPUT: 'Console output',
        COPY_TO_CLIPBOARD: 'Kopier til udklipsholder',
        DEBUGGER: 'Debugger',
        DEBUGGER_CONNECTION_ERROR: 'Fejl ved oprettelse af debugger-forbindelse',
        EXPORT_TO_JSON: 'Eksporter til json',
        HIDE_FROM_USER: 'Skjul {thing} for brugeren',
        NO_CHANGES:
          '<p>Ingen ændringer <em>indenfor valgte tidsrum</em>.</p><p>Prøv evt at vælge en dato længere tilbage i tiden.</p>',
        TAGGED_ONLY: 'Kun tagget',
        TIME: 'Tid',
        TIMESTAMP: 'Tidsstempel',
        LOG: 'Log',
        LOG_TRUNCATED: 'Der vises kun de sidste {maxLines} linier af loggen ...',
        STATE: 'Tilstand',
        AUTHOR: 'Forfatter',
        TAG: 'Tag',
        ENTER_TAG: 'Indtast tag',
        REVERT: 'Gendan',
        REVERTED: 'Gendannet {thing}',
        REVERT_ACTION: 'Gendan {thing}',
        REVERT_TOOLTIP: 'Gendan til denne version',
        CHANGE: 'Viser {tag} fra for {fromNow}',
        UNTAGGED: 'en version',
        CHANGE_ABORT: 'Afbryd',
        CHANGE_REVERT: 'Gendan denne version',
        CODE: 'Kode',
        COLOR: 'Farve',
        CONFIGURATION: 'Konfiguration',
        APPLY_SETTINGS: 'Anvend indstillinger',
        COPY: 'Kopier {thing}',
        COPY_CONFIRM: 'Er du sikker på du vil kopiere {thing}?',
        COPIED: 'Kopierede {thing}',
        COPIED_BY: 'kopieret af {name}',
        CREATE: 'Opret {thing} {name}',
        CREATED: 'Oprettede {thing}',
        DASHBOARD: 'Dashboard',
        DELAY: 'Forsinkelse',
        DELETE: 'Slet {thing}',
        DELETE_CONFIRM_MESSAGE: 'Er du sikker på, at du vil slette {thingType} {thingName}?',
        DELETED: 'Slettede {thing}',
        DESCRIPTION: 'Beskrivelse',
        DISABLE_AUTOSAVE: 'Deaktiver kodeautosave af flows, der er forbundet med denne gruppe',
        DISABLE_FLOW_CODE_EDITING:
          'Deaktiver redigering af flows, der er forbundet med denne gruppe',
        PROMPT_ON_ADD_MESSAGE: 'Advarsel ved tilføjelse',
        PROMPT_ON_REMOVE_MESSAGE: 'Advarsel når gruppen fjernes',
        PROMPT_ON_ADD: 'Spørg efter bekræftelse, inden du tilføjer denne gruppe',
        PROMPT_ON_REMOVE: 'Spørg efter bekræftelse, før du fjerner denne gruppe',
        EDIT: 'Rediger {thing} {name}',
        ENTER_CUESTA: 'Log ind i {productName}',
        EMAIL: 'Email',
        ERR: '{action} fejlede',
        ERR_OUTDATED_VERSION: '{action} fejlede. Din version af {thing} er ikke opdateret.',
        ERR_NOT_UNIQUE: '{action} fejlede. {thing} med den {property} eksisterer.',
        EXECUTABLE: 'Executable',
        FIELD: 'felt | felter',

        FIELD_POINT_AND_CLICK: 'Peg og klik',
        FIELD_SETTINGS: 'Indstillinger',
        FIELD_IDENTIFICATION_TYPE: 'Type',
        FIELD_PATH_IDENTIFICATION: 'Sti',
        FIELD_OPTICAL_IDENTIFICATION: 'Optisk',
        FIELD_TESTING: 'Test',
        FIELD_TEST_CLICK: 'Klik',
        FIELD_TEST_RUN: 'Kør',
        FIELD_TEST_MISC: 'Diverse',
        FIELD_ALTERNATIVE_DELETE: 'Fjern',
        FIELD_ALTERNATIVE_DELETE_CONFIRM: 'Vil du slette dette alternativ?',
        FIELD_LOCATOR_IMAGE: 'Billede',
        FIELD_LOCATOR: 'alternativ',
        FIELD_LOCATOR_INCLUDE_INVISIBLE: 'find usynlige',
        FIELD_PRIMARY: 'Primær {type}',
        FIELD_ALTERNATIVE: 'Alternativ {type} #{index}',
        FIELD_USE_PATH_EDITOR: 'Marker sti-elementer',
        FIELDS_AND_FLOWS: 'Flows & Felter',
        FIELD_NOT_USED: 'Felt er ikke brugt i nogen Flow',
        FIELD_ALTERNATIVE_EMPTY: 'Dette alternativ er ikke udfyldt',
        FILTER_BY: 'Filter på {thing}',
        FLOW_NOT_USED: 'Flow er ikke brugt i nogen Flow',
        FLOW: 'flow | flows',
        FLOW_COUNT: 'ingen flows | et flow | {etnt} flows',
        FLOWS_APPLICATION_WARNING: 'Flows app er ikke i gruppen',
        FLOW_EDIT_NOT_FOR_THIS_MAINTAINER: 'Flow redigering er ikke tilladt for denne bruger.',
        FRAME_CONTAINS: 'Frame indeholder',
        GLOBAL_SEARCH: 'Global søgning',
        GROUP: 'gruppe | grupper',
        GROUP_BY: 'Grupper efter {thing}',
        GROUP_GENERAL_SETTINGS: 'Gruppens generelle indstillinger',
        GROUP_NOT_IN_APPLICATION: 'Den valgte gruppe {group} er ikke til stede på applikationen',
        GROUP_ADD_TO_APP_QUESTION:
          'Gruppen {group} er ikke på flowets app. Vil du tilføje den til {app} nu?',
        GROUP_ADD_TO_APP_FAILURE: 'Det lykkedes ikke at tilføje {group} til {app}!',
        GROUP_FLOW_SETTINGS: 'Gruppens flow indstillinger',
        IMPORT_FROM_FILE_ERROR: 'Der opstod en fejl under import af {thing} fra filen',
        INPUT: 'input | inputs',
        INPUT_HERE: 'dit input her',
        INCLUDED_MODULE_FLOW_WITH_UNDEFINED_FIELDS:
          'Nogle af de inkluderede modul flows ({flows}) refererer felter, som ikke er defineret for denne applikation',
        IDENTIFYING_FLOW_NAME: '{appName} {appVersion} / {flowName}',
        IDENTIFYING_APP_NAME: '{appName} {appVersion}',
        'JAVA-AWT': 'Java AWT',
        'JAVA-AWT-DESCRIPTION':
          'Forbinder sig til java applikationer. Kan starte applikationen, hvis den ikke kører',
        'JAVA-SWING': 'Java Swing',
        KEY: 'Nøgle',
        LAUNCH_SECTION: 'Opstart med parametre',
        LAUNCH_SECTION_FLOW: 'Opstart med flow',
        LAUNCHWITH: 'Start med',
        LAUNCHTIMEOUT: 'Start timeout',
        TRIGGER_NO_LAUNCH: 'Kør kun hvis app allerede kører',
        LAST_EDITED_BY: 'Senest redigeret af',
        LESS_SETTINGS: 'Færre settings',
        LOADING: 'Loading',
        LOGIN: 'Log ind',
        LOGOUT: 'Logout',
        MAINTAINER: 'Vedligeholdt af | Vedligeholdt af',
        MANUFACTURER: 'producent | producenter',
        MORE_SETTINGS: 'Flere indstillinger',
        MQ: 'Beskedkø',
        MQ_CONFIG_ENCODING: 'Tegnsæt',
        MQ_CONFIG_EXCHANGE: 'Exchange',
        MQ_CONFIG_HOST: 'Server-navn eller IP-addresse',
        MQ_CONFIG_PORT: 'Port',
        MQ_CONFIG_QUEUE_NAME: 'Kø navn',
        MQ_CONFIG_ROUTING_KEY: 'Bindingsnøgle',
        MQ_CONFIG_USER: 'Brugernavn',
        MQ_CONFIG_PASS: 'Adgangskode',
        MQ_CONFIG_VHOST: 'Virtuel host',
        MQ_META: 'Beskeder publiceret til {serviceName}',
        MQ_SERVICE: 'Beskedkø',
        MQ_SERVICE_TRIGGER: 'Beskedkø initiator',
        MQ_SETTINGS: 'Beskedkø indstillinger',
        MQ_TRIGGER_CLAIM_MATCH: 'Krævet JWT claim (regexp)',
        MQ_TRIGGER_MESSAGE_MATCH: 'Besked match (regexp)',
        MQ_TRIGGER_REPLY_EXPECTED: 'Svar til afsender',
        NAME: 'Navn',
        NAMED: 'Navngivet',
        NATIVE: 'Window Native',
        'NATIVE-DESCRIPTION':
          'Forbinder sig til windowsapplikationer. Kan starte applikationen, hvis den ikke kører',
        NEW: 'Opret {thing}',
        ENABLE_DEBUGGER: 'Aktivér debugger',
        NO_ITEMS_MATCH: 'Ingen {things} matcher din søgning',
        NO_SELECTION: 'Intet valgt',
        NO_THING_YET: 'Ingen {thing} endnu',
        NO_MORE_ITEMS: 'Ikke flere muligheder',
        OR: 'eller',
        OR_SHORT: 'el.',
        OUTPUT: 'output | outputs',
        USERNAME: 'Brugernavn',
        UNSAVED_CHANGES: 'Du har ikke-gemte ændringer. Vil du forlade og forkaste dine ændringer?',
        PASSWORD: 'Adgangskode',
        PATH: 'Sti',
        PINMENU: 'Fastgør menu',
        READ: 'Læs {thing}',
        REGEX: 'Regulært udtryk',
        REGEX_HINT: 'Regex',
        REMOVE_ITEM_CONFIRM: 'Er du sikker på, at du vil fjerne elementet {thing}?',
        RESET_COLOR: 'Nulstil farve',
        SEARCH: 'Søg...',
        SEARCH_IN: 'Søg i {thing}',
        SERIALPORT: 'Serielport',
        SERIALPORT_BAUD: 'Baud',
        SERIALPORT_DATABITS: 'Data bits',
        SERIALPORT_ENCODING: 'Tegnsæt',
        SERIALPORT_HANDSHAKE: 'Signalering',
        SERIALPORT_MESSAGE_MATCH: 'Trigger tekst',
        SERIALPORT_META: '{serviceName} sender besked, der matcher {messagePattern}',
        SERIALPORT_PARITY: 'Paritet',
        SERIALPORT_PORT_PATTERN: 'Port navn',
        SERIALPORT_SERVICE: 'Serielport | Serielporte',
        SERIALPORT_SERVICE_TRIGGER: 'Serielport data',
        SERIALPORT_SETTINGS: 'Portindstillinger',
        SERIALPORT_STOPBITS: 'Stop bits',
        SERVICE_TRIGGER: 'Service trigger',
        SETTINGS: 'Indstillinger',
        SHORTCUT: 'Tastaturgenvej | Tastaturgenveje',
        SHORTCUTS_GLOBAL: 'Global tastaturgenveje',
        SHORTCUTS_WINDOW: 'Vinduespecifikke tastaturgenveje',
        SUBJECT: 'subject | subjects',
        SUBJECTPREFIX: 'Subject prefix | Subject prefixes',
        SUPERFLOWS: 'Superflow | Superflows',
        STOP: 'Stop',
        TITLEBAR_CONTAINS: 'Titel-baren indeholder',
        TRY_AGAIN: 'Prøv venligst igen',
        TYPE: 'Type | Typer',
        FLOW_TYPE: 'Flow-type',
        TYPE_CONFIG: 'Konfiguration af type',
        UNDEFINED_CONSTRAINT: 'Din kode indeholder udefinerede {things}.',
        UNDEFINED_CONSTRAINT_ELEMENTS: 'Udefinerede {things}: {list}.',
        UNDEFINED_CONSTRAINT_EX: 'For at {action}, slet venligst {subjects}: {list}.',
        UNDEFINED_REFERENCE_ERROR: "Udefineret {thing} '{thingName}'",
        INCLUDE_WITH_BAD_REFERENCES_ERROR:
          "Modulet '{name}' refererer ugyldige felter for denne app:\n{lines}",
        UNIQUE_CONSTRAINT: '{thing} skal være unik.',
        UNIQUE_CONSTRAINT_EX: '{thing} {verb} {subject} findes allerede.',
        UPDATE: 'Opdater {thing}',
        UPDATE_HELP: 'Gem dine ændringer',
        UPDATED: 'Opdaterede {thing}',
        UPLOAD: 'Upload {thing}',
        UPLOADED: 'Uploadet',
        USED_CONSTRAINT: '{thing} bruges i app.',
        USED_CONSTRAINT_EX: 'For at {action} skal den først slettes fra {list}.',
        USED_IN: 'Brugt i {thing}',
        USER: 'bruger | brugere',
        NO_USER_HEADER: 'Manglende bruger',
        NO_USER_BODY:
          'Der er ingen bruger med {withName} som brugernavn. Opret en ny bruger og angiv dit brugernavn som navn via linket nedenfor.',
        URL_CONTAINS: 'URL indeholder',
        VERSION: 'Version | Versioner',
        VIEW: 'View',
        LANGUAGE: 'sprog',
        LANGUAGE_ES5: 'ældre Javascript (ES5)',
        LANGUAGE_MODERN: 'moderne Javascript',
        OPEN_PAGE_IN: 'Åbn siden i',
        OPEN_PAGE_IN_APP: 'App vindue',
        OPEN_PAGE_IN_INCOGNITO: 'Incognito vindue',
        OPEN_PAGE_IN_TAB: 'Ny fane',
        OPEN_PAGE_IN_WINDOW: 'Nyt vindue',
        OPTIONS: 'Valgmuligheder',
        WARN_REQUIRED: 'For at {action}, indsæt venligst værdi i {thing}.',
        WARN_INCORRECT_INPUT: 'For at {action}, indsæt venligst validt værdier i indikerede felter',
        WARN_OUTDATED:
          '{thing} blev opdateret andetsteds. Du skal refreshe siden for at få de nye ændringer - husk at kopiere dit nuværende {thing} hvis du har lavet noget der skal gemmes!',
        'WEB-CHROME': 'Web Chrome',
        'WEB-CHROME-DESCRIPTION':
          'Forbinder sig til indlæste sider i en Chrome browser. Kan starte Chrome, hvis den ikke kører i forvejen eller åbne nye faner i Chrome, hvis den ønskede side ikke allerede er vist. Find den påkrævede Chrome udvidelse <a href="https://chrome.google.com/webstore/detail/sirenia-chrome-driver/lbokehfhhclmidfioacglfeigplbccdj" target="_blank">her</a>.',
        'WEB-FF': 'Firefox',
        'WEB-FF-DESCRIPTION':
          'Forbinder sig til indlæste sider i en Firefox browser. Kan starte Firefox, hvis den ikke kører i forvejen eller åbne nye faner i Firefox, hvis den ønskede side ikke allerede er vist. Find den påkrævede Firefox udvidelse <a href="https://firefox.sirenia.io" target="_blank">her</a>.',
        HEADLESS: 'Headless',
        'HEADLESS-DESCRIPTION':
          'Binder sig ikke til kørende applikationer. Denne type er velegnet til flows, der udfører selvstændigt arbejde uafhængigt af kørende applikationer.',
        'WEB-IE': 'Web IE',
        'WEB-IE-DESCRIPTION':
          'Forbinder sig til indlæste sider i en Internet Explorer browser. Kan starte Internet Explorer, hvis den ikke kører i forvejen.',
        'WEB-IE-PROXY': 'Web IE (eksperimentel)',
        'WEB-IE-PROXY-DESCRIPTION':
          'Eksperimentel udgave af IE driveren. Bemærk: Supporteres ikke længere. Brug Web IE typen i stedet - eller en anden browser.',
        'WEB-HCHROME': 'Web Chrome (indbygget)',
        'WEB-HCHROME-DESCRIPTION':
          'Bruger en indbygget chrome browser til at åbne hjemmesider og automatiserer brugen af alle sider, den viser. Forbinder sig ikke til almindelige chrome browsere eller allerede kørende indbyggede chrome browsere.',
        'WEB-EDGE': 'Web Edge',
        'WEB-EDGE-DESCRIPTION':
          'Forbinder sig til indlæste sider i en Edge browser. Kan starte Edge, hvis den ikke kører i forvejen eller åbne nye faner i Edge, hvis den ønskede side ikke allerede er vist. Find den påkrævede Edge udvidelse <a href="https://chrome.google.com/webstore/detail/sirenia-chrome-driver/lbokehfhhclmidfioacglfeigplbccdj" target="_blank">her</a>.',
        'WEB-HIE': 'Web IE (indbygget)',
        'WEB-HIE-DESCRIPTION':
          'Bruger en indbygget IE browser til at åbne hjemmesider og automatiserer brugen af alle sider, den viser. Forbinder sig ikke til almindelige IE browsere eller allerede kørende indbyggede IE browsere.',
        CONTEXTPARTICIPANT: 'Context Participant (CCOW)',
        'CONTEXTPARTICIPANT-DESCRIPTION':
          'Forbinder sig til en CCOW kompatibel applikation via en af de understøttede protokoller; JSON/HTTP, JSON-RPC/WS eller PROTOBUF/GRPC. Se <a href="https://docs.sirenia.io/manatee/v1.29/external-apis/overview/">denne side</a> for udvikler-instruktioner.',
        APPLICATION_IDENTITY_SECTION: 'Identificer applikationen',
        APPLICATION_IS_EMBEDDED: 'Indlejret app',
        APPLICATION_LEGACY_BROWSER: 'Ældre IE',
        EXECUTABLE_PATH_CONTAINS: 'Eksekverbar-sti indeholder',
        LAUNCH_WITH: 'Start via',
        PROCESS_CONTAINS: 'Proces-navn indeholder',
        PROCESS_PATH_CONTAINS: 'Processens sti indeholder',
        UNKNOWN: 'Ukendt',
        UNKNOWN_ERROR: 'Ukendt fejl',
        FLOW_DETAILS_HEADER: 'Flow detaljer',
        OWNERSHIP_HEADER: 'Ejerskab',
        SHOW_SUGGESTIONBOX: 'Vis forslag',
        SHOW_HELP: 'Vis hjælp',
        HIDE_SUGGESTIONBOX: 'Gem forslag',
        SHOW_SHORTCUTS: 'Vis tastaturgenveje',
        HIDE_SHORTCUTS: 'Gem tastaturgenveje',
        SHORTCUT_AUTOCOMPLETE: 'Autofuldførelse',
        SHOW_MINIMAP: 'Vis minimap',
        SHORTCUT_BEAUTIFY: 'Auto-formater kode',
        SHORTCUT_BEAUTIFY_KEY: '⌃ B',
        SHORTCUT_START_SEARCHING: 'Start søgning',
        SHORTCUT_FIND_NEXT: 'Find næste',
        SHORTCUT_FIND_PREVIOUS: 'Find tidligere',
        SHORTCUT_REPLACE: 'Udskift',
        SHORTCUT_REPLACE_ALL: 'Udskift alle',
        SHORTCUT_JUMP_TO_LINE: 'Gå til linje',
        SHORTCUT_ADD_SELECTION: 'Multi-cursor - næste match',
        SHORTCUT_SHOW_COMMAND_PALETTE: 'Vis kommandopaletten',
        SHORTCUT_RUN_FLOW: 'Kør flow',
        SHORTCUT_DEBUG_FLOW: 'Debug flow',
        SERVER_ERROR: 'Intern serverfejl',
        INPUT_AND_OUTPUT_HEADER: 'Inputs og outputs',
        TRIGGER_HEADER: 'Initiatorer',
        TRIGGER: 'initiator | initiatorer',
        TRIGGER_META: 'Vælg en ny type initiator at tilføje',
        NONE: 'Ingen {things}',
        CONTEXT_TRIGGER: 'Context-baseret initiator',
        CONTEXT_TRIGGER_CHANGE: 'Ændring',
        CONTEXT_META: 'Ændring i {subject}, fra {oldmatch} til {newmatch}',
        LIFECYCLE: 'Livs-cyklus',
        GLOBAL_LIFECYCLE_EVENT: 'Global hændelse | Globale hændelser',
        APP_LIFECYCLE_EVENT: 'Hændelse i app | Hændelser i en app',
        URL: 'url',
        CURRENT_APPLICATION: 'Nuværende app',
        FROM: 'Fra {thing}',
        TO: 'Til {thing}',
        LIFECYCLE_TRIGGER: 'Livs-cyklus baseret initiator',
        LIFECYCLE_META: 'Når <i>{event}</i> sker',
        LIFECYCLE_NAVIGATED_META:
          'Ved navigering fra <span class="monospaced">{fromUrl}</span> til <span class="monospaced">{toUrl}</span>',
        LIFECYCLE_EVENT: 'Hændelse',
        LIFECYCLE_TRIGGER_ATTACHED: 'Ved start af applikationen',
        LIFECYCLE_TRIGGER_DETACHED: 'Ved applikationens afslutning',
        LIFECYCLE_TRIGGER_MANATEESTARTED: 'Ved Manatee start',
        LIFECYCLE_TRIGGER_NAVIGATED: 'Navigering',
        EXTERNAL_TRIGGER: 'Ekstern initiator',
        ANCHOR_HEADER: 'Forankring',
        ANCHOR: 'Anker',
        OLD: 'Tidligere {thing}',
        CONTEXT_TRIGGER_VALUE: 'Værdi',
        POSITIONAL_FIELDS_USED:
          'Din kode indeholder felter: {fields}, som bruger positionelle ankre.',
        POSITIONAL_FIELDS_USED_EX: 'Hvis muligt brug felter uden ankre: {positional}.',
        PROPERTY: 'Egenskab',
        LAUNCHWITHARGUMENTS: 'Argumenter',
        WINDOW_SHOWN: 'Vist',
        WINDOW_HIDDEN: 'Gemt',
        WINDOW: 'Vinduer',
        WINDOW_EVENT: 'Hændelse',
        HOTKEY: 'Hotkey',
        HOTKEY_META: 'Tryk {modifiers} og {keys} for at aktivere flow',
        WINDOW_TITLE: 'Vindues title',
        WINDOW_CLASS: 'Vindues klasse',
        CLOSE_WINDOW: 'Luk det fundne vindue?',
        HOTKEY_MODIFIER: 'Hotkey modifier tast',
        HOTKEY_KEY: 'Hotkey tast',
        INVALID_FILE: 'Uploadet fil er ugyldig',
        INVALID_HOTKEY: 'Invalid hotkey. Mindst en modifier tast og en normal tast er krævet.',
        TABLE: 'tabel | tabeller',
        TABLE_INSERT_ROW: 'Indsæt række',
        TABLE_DELETE_ROW: 'Slet række',
        TABLE_MOVE_CELL_LEFT: 'Flyt en celle tilbage',
        TABLE_MOVE_CELL_RIGHT: 'Flyt en celle til højre',
        TABLE_MOVE_ROW_UP: 'Flyt en række op',
        TABLE_MOVE_ROW_DOWN: 'Flyt en række ned',
        TABLE_SELECT_ROW: 'Vælg række',
        TABLE_META: 'Kør flow når den valgte tabel opdateres',
        TABLE_VERY_LARGE_WARNING:
          'Den valgte tabel er *meget* stor. Dette vil muligvis forårsage en del trafik på netværket.',
        DATA: 'Data',
        ROW: '{count} række | {count} rækker',
        COLUMN: '{count} kolonne | {count} kolonner',
        NO_ROWS: 'Ingen rækker i tabel',
        NO_MATCH_HEADER: 'Intet fundet',
        NO_MATCH: 'Intet fundet for "{term}"',
        DETAILS: 'Detaljer',
        CRON: 'Cron',
        CRON_SECOND: 'Sekund',
        CRON_MINUTE: 'Minut',
        CRON_HOUR: 'Time',
        CRON_DAYOFMONTH: 'Dag i måned',
        CRON_MONTH: 'Måned',
        CRON_DAYOFWEEK: 'Ugedag',
        CRON_HUMAN_DESC: 'Flow vil køre efter flg skema:',
        CRON_NEXT: 'Næste kørsel:',
        WORKINGDIRECTORY: 'Arbejds-folder',
        COMM_ERROR_HEADER: 'Kommunikations-fejl',
        COMM_ERROR_BODY: 'Der opstod en kommunikations-fejl. Du bedes logge ind igen.',
        FINDING_THE_FIELD: 'Find feltet',
        IMAGE: 'Screenshot',
        IDENTIFIER: 'Id',
        NO_IMAGE: 'Intet screenshot',
        X_OFFSET: 'X offset',
        Y_OFFSET: 'Y offset',
        MATCH_CONFIDENCE: 'Match grænse',
        DETECT_FIELD: 'Find felt',
        GRAB_SCREENSHOT: 'Tag screenshot',
        CONNECTION_FAILED: 'Ingen forbindelse',
        NO_MANATEE_CONNECTION: 'Kører Manatee? Der kunne ikke oprettes forbindelse{code}',
        MISSING_APPLICATION: 'App ikke fundet',
        MISSING_APPLICATION_MESSAGE: 'Manatee kan ikke se en matchende applikation',
        MANATEE_CERTIFICATE_EXPIRED:
          'Manatee bruger et udløbet cetifikat. Giv venligst en administrator besked',
        FIELD_FINDER_FAIL: 'Feltfinder problem',
        FIELD_FINDER_FAIL_INIT_MSG: 'Fejlbesked: {cause}',
        MODULE: 'Modul',
        SERVICE: 'service | services',
        MAIL_SERVICE: 'Mail',
        MAIL_SERVICE_TRIGGER: 'Mail service',
        MAIL_SERVICE_TRIGGER_META: '',
        MAIL_SERVICE_TYPE: 'Mail service type',
        MAIL_SERVICE_TYPE_IMAPSMTP: 'IMAP',
        MAIL_SERVICE_TYPE_EXCHANGE: 'Exchange Server',
        EXCHANGE_SERVICE_URL: 'Exchange Web Service addresse',
        EXCHANGE_USERNAME: 'Brugernavn',
        EXCHANGE_PASSWORD: 'Adgangskode',
        EXCHANGE_USE_LEGACY_MODE: 'Ældre server (før 2010 SP1)',
        FROM_ADDRESS: 'Fra',
        TO_ADDRESS: 'Til',
        CC_ADDRESS: 'Cc',
        MAIL_SUBJECT: 'Emne',
        MAIL_BODY: 'Tekst',
        ATTACHMENTS: 'Vedhæftede filer',
        SERVICE_NAME: 'Service navn',
        SERVICE_NAME_PLACEHOLDER: 'Angiv navn til service',
        SERVICE_KEY: 'Service nøgle',
        SERVICE_KEY_PLACEHOLDER: 'Angiv unik nøgle til service',
        IMAP: 'IMAP',
        IMAP_HOST: 'Server-navn eller IP-addresse',
        IMAP_HOST_PLACEHOLDER: 'Angiv et server-navn til IMAP server',
        IMAP_PORT: 'Port',
        IMAP_PORT_PLACEHOLDER: 'Angiv en port til IMAP server',
        IMAP_USERNAME: 'Brugernavn',
        IMAP_USERNAME_PLACEHOLDER: 'Angiv brugernavn for IMAP user',
        IMAP_PASSWORD: 'Adgangskode',
        IMAP_PASSWORD_PLACEHOLDER: '',
        SMTP: 'SMTP',
        SMTP_HOST: 'Server-navn eller IP-addresse',
        SMTP_HOST_PLACEHOLDER: 'Angiv et server-navn til SMTP server',
        SMTP_PORT: 'Port',
        SMTP_PORT_PLACEHOLDER: 'Angiv en port til SMTP server',
        SMTP_USERNAME: 'Brugernavn',
        SMTP_USERNAME_PLACEHOLDER: 'Angiv brugernavn for SMTP user',
        SMTP_PASSWORD: 'Adgangskode',
        SMTP_PASSWORD_PLACEHOLDER: '',
        SERVICE_NOT_USED: 'Service ikke brugt',
        TITLE_TYPE_NAME: '{type} > {name}',
        TITLE_TYPE: '{type}',
        FILESYSTEM: 'Filsystem',
        FILESYSTEM_META: 'Kør for filer i folderen der matcher "{match}"',
        FILESYSTEM_DIRECTORY: 'Folder',
        FILESYSTEM_MATCH: 'Match',
        KEYBOARD: 'Keyboard',
        KEYBOARD_META_DEBOUNCE:
          'Keyboard/scanner input uden pauser over {debounceMs}ms matcher {match}',
        KEYBOARD_META_LOOKBACK: 'Keyboard/scanner input indenfor {lookbackMs}ms matcher {match}',
        KEYBOARD_LOOKBACKMS: 'Fuld tekst indenfor (ms)',
        KEYBOARD_MATCH: 'Match',
        KEYBOARD_DEBOUNCEMS: 'Tastning med pauser under (ms)',
        KEYBOARD_MATCH_DEBOUNCE_MODE: 'Tastepause - forsinket',
        KEYBOARD_MATCH_LOOKBACK_MODE: 'Tidsvindue - øjeblikkelig',
        KEYBOARD_MATCH_MODE: 'Funktion',
        KEYBOARD_MATCH_PLACEHOLDER: 'Input mønster',
        MATCH_ON_DESKTOP: 'Find billedet på hele desktoppen',
        MANDATORY_STATE: 'Er tilstanden obligatorisk for applikationen?',
        SUGGESTION: '{type}',
        PRECOMPILE_FLOW: 'Kompiler flow på forhånd',
        WEBSOCKET_HOST: 'Adresse',
        WEBSOCKET_PORT: 'Port',
        WEBSOCKET_SECURE: 'Kryptering',
        INTERCEPT_EVENT: 'Opfang hændelse',
        INTERCEPT_META: 'Når hændelsen "{eventType}" opfanges på "{fieldName}".',
        INTERCEPT_EVENTTYPE: 'Hændelsestypen',
        INTERCEPT_LEFTCLICK: 'Klik med venstre muse-knap',
        INTERCEPT_RIGHTCLICK: 'Klik med højre muse-knap',
        INTERCEPT_NO_FIELD: 'Angiv et felt',
        INTERCEPT_NO_EVENTTYPE: 'Angiv hændelsestype',
        TRIGGER_ENABLED: 'Aktiveret',
        PATH_TOKENS_NOT_UNIQUE: 'Ikke unikke',
        JVMLOCATION: 'JVM placering',
        FULLNAME: 'Fuldt navn',
        VALIDATIONERRORS: 'Ret venligst følgende fejl',
        MISSINGUSERNAME: 'Mangler brugernavn',
        PASSWORDTOOSIMPLE: 'Adgangskoden er for simpel',
        PASSWORDSUGGESTIONS: 'Du kan gøre følgende for at forbedre din adgangskode (på engelsk)',
        USER_IS_ADMIN: 'Super-bruger',
        REPEATPASSWORD: 'Gentag adgangskode',
        CREATEUSERWITHPASSWORD_HELP:
          'Hvis du angiver en adgangskode her vil brugeren kunne logge ind med dette. Super-brugere kan desuden administrere brugere.',
        RESETUSERPASSWORD_HELP: 'Ændr din adgangskode',
        PASSWORD_OK: 'Din adgangskode er godkendt.',
        DISABLE_KNOWN_EXECUTABLE: 'Husk ikke sidste succesfulde sti til applikation',
        AUTOCOMPLETION: 'Kodeforeslag',
        SNIPPET: 'eksempel | eksempler',
        USE_SNIPPETS: 'Brug eksempler (i kodeforslag)',
        USE_TYPES: 'Brug typesystem (i kodeforslag)',
        COMPATIBLE_WITH: 'Kompatibel med Manatee i version',
        RUNTIME_PROPERTIES: 'Indstiller for flow-kørsel',
        SWITCH: 'Skift {thing}',
        EDITORSETTINGS: 'Editor indstillinger',
        TOO_MANY_MATCHES: 'For mange resultater ({omitted} udeladt)',
        TOO_MANY_FLOWS_TO_SHOW: 'Kan ikke vise alle flows',
        PREFERENCES: 'Dine indstillinger',
        PREFERENCES_CATEGORIES: 'Kategorier',
        PREFERENCES_EDITOR: 'Flow editor',
        PREFERENCES_MISC: 'Diverse',
        ENABLE_AUTO_SAVE: 'Gem automatisk',
        ENABLE_AUTO_APP_GROUP: 'Tilføj gruppe til app, når den tilføjes til flow',
        RESET_TO_DEFAULTS: 'Nulstil',
        RESET_TO_DEFAULTS_CONFIRM_MESSAGE: 'Nulstil {thing} til defaults?',
        RESTORE_FOCUS_AFTER_FLOW: 'Gendan nuværende vindues fokus efter flow',
        MOVE: 'Flyt {thing} {direction}',
        DIRECTION_UP: 'op',
        DIRECTION_DOWN: 'ned',
        DIRECTION_LEFT: 'til venstre',
        DIRECTION_RIGHT: 'til højre',
        NEXT_PAGE: 'Næste side',
        PREV_PAGE: 'Forrige side',
        LAST_PAGE: 'Sidste side',
        FIRST_PAGE: 'Første side',
        MENU_SIRENIA_EXTENSION: 'Udvidelse',
        INTERCEPT_ALLOWOUTSIDEWINDOW: 'Tillad trigger udenfor vindue',
        INTERCEPT_ALLOWUNFOCUSED: 'Tillad trigger for vindue uden fokus',
        MANATEE_COUNT: '{count} Manatee | {count} Manatees',
        KITCHENTABLE_ITEMCOUNT: '{count} række | {count} rækker',
        KITCHENTABLE_PAGE: 'Side {current} ud af {total}',
        KITCHENTABLE_EMPTY: 'Ingenting at vise her',
        ESTERO: 'Conductor',
        MANATEE_VERSION: 'Manatee version',
        ESTERO_SIMPLE: 'Simpel forespørgsel',
        ESTERO_ADVANCED: 'Avanceret forespørgsel',
        ESTERO_SIMPLE_LABEL: 'Lav et filter for Manatees her',
        ESTERO_SIMPLE_HELP_LINK: 'https://docs.sirenia.io/cuesta/v1.15/#mql',
        ESTERO_ADVANCED_EDITOR_LABEL: 'Indtast en MQL forespørgsel her',
        ESTERO_ADVANCED_EDITOR_HELP_LINK:
          'https://docs.sirenia.io/cuesta/v1.15/#filtering-manatees',
        SHOW_CONTROLS: 'Vis kontroller',
        ESTERO_VIEWCODE: 'Vis kode',
        SAVED_VIEW: 'gemt søgning | gemte søgninger',
        MACHINENAME: 'Maskin navn',
        USERDOMAIN: 'Domæne',
        PRODGROUP: 'Primær gruppe',
        RUNNING_FLOW: 'Kører flow',
        NO_RUNNING_FLOW: 'Klar',
        MANATEE: 'manatee | manatees',
        MANATEE_UPTIME: 'Oppetid',
        ESTERO_DETAILS: 'Detaljer for Manatee {id}',
        ESTERO_COL_DETAILS: ' ',
        ESTERO_RUN_FLOW: 'kør flow',
        ESTERO_RESET_SETTINGS: 'reset indstillinger',
        ESTERO_SAVE_SETTINGS: 'gem indstilling | gem {count} indstillinger',
        ESTERO_RESET_SETTINGS_CHANGES: 'forkast ændringer',
        ESTERO_RESTART: 'genstart',
        ESTERO_SHUTDOWN: 'afslut',
        ESTERO_CONFIRM: 'Er du sikker på at du vil {action}e?',
        SEARCH_OPERATOR_EQUALS: 'er lig med',
        SEARCH_OPERATOR_NOT_EQUALS: 'er ikke lig med',
        SEARCH_OPERATOR_LESS_THAN: 'er mindre end',
        SEARCH_OPERATOR_LESS_THAN_OR_EQUALS: 'er mindre end eller lig med',
        SEARCH_OPERATOR_GREATER_THAN: 'er større end',
        SEARCH_OPERATOR_GREATER_THAN_OR_EQUALS: 'er større end eller lig med',
        SEARCH_OPERATOR_STARTS_WITH: 'starter med',
        SEARCH_OPERATOR_ENDS_WITH: 'ender med',
        SEARCH_OPERATOR_CONTAINS: 'indeholder',
        SEARCH_OPERATOR_CONTAINS_NOT: 'indeholder ikke',
        SEARCH_OPERATOR_MATCHES_REGEXP: 'matcher regexp',
        ESTERO_SIMPLE_MENU_PROP: 'Vælg egenskab',
        ESTERO_SIMPLE_MENU_OPERATOR: 'Vælg operator',
        ESTERO_SIMPLE_MENU_VALUE: 'Værdi der skal matche',
        ESTERO_FIND_FLOW: 'Find flow',
        ESTERO_SPECIFY_INPUTS: 'Angiv inputs',
        ESTERO_CONNECTION_LOST_HEADER: 'Forbindelse mistet',
        ESTERO_CONNECTION_LOST_BODY: 'Forbindelse til Conductor er mistet',
        ESTERO_FLOW_RESULTS: 'Flow resultater',
        ESTERO_FLOW_NO_RESULTS: 'Flow kørt',
        ESTERO_FLOW_ERROR: 'Flow fejlede med {err}',
        ESTERO_FAIL: 'Fejl i {action}',
        MANATEE_BRANCH: 'Branch',
        RUN: 'Kør',
        YES: 'Ja',
        NO: 'Nej',
        OK: 'Ok',
        CANCEL: 'Afbryd',
        ESTERO_SUCCESS: '{action} lykkedes',
        THEME: 'Visuelt tema',
        THEME_BROWSER: 'Browser tema',
        THEME_LIGHT: 'Lyst tema',
        THEME_DARK: 'Mørkt tema',
        SETTING: 'indstilling | indstilllinger',
        SETTING_TARGET_HEADER: 'Vælg primær gruppe og version som disse indstillinger gælder for',
        SETTING_HEADER: 'Tilføj indstillinger',
        SETTING_VALUE: 'Indstillingens værdi',
        SETTING_KEY: 'Indstillingens nøgle',
        SETTING_INVALID_VALUE: 'Ugyldig værdi for denne indstilling. {instruction}',
        SETTING_INVALID_INSTRUCTIONS_URL: 'Angiv en url.',
        SETTING_INVALID_INSTRUCTIONS_REGEXP:
          'Angiv en streng der matcher det regulære udtryk "{regexp}".',
        SETTING_NOT_SUPPORTED_IN_VERSION: 'Indstillingen kan ikke sættes i den valgte version.',
        SETTING_GROUP_VERSION_NOT_UNIQUE: 'Gruppe og version skal være unikke.',
        SETTING_INVALID_TYPED: 'Værdi skal være af typen {type}.',
        ACCESS_DENIED: 'Du har ikke adgang til {location}. Kontakt evt en administrator.',
        ERROR_CONFLICTING_FLOW: 'Dette flow findes allerede',
        ERROR_CONFLICTING_FLOW_SAME_APP:
          'Navn eller subject er i konflikt med eksisterende flow {conflictingFlow}',
        WARN_CONFLICTING_FLOW_OTHER_APP:
          "Et lignende flow med navnet {conflictingFlow} findes allerede i app'en {conflictingApp}. Fortsæt alligevel?",
        WINDOW_META: '{type} for vindue med titel "{title}" og klasse "{class}"',
        POPUP_HANDLING: 'Popup vindues håndtering',
        EXACT_MATCH: 'matcher præcist {thing}',
        OPEN_POPUP: 'Åbn nye popup vinduer i {in}',
        POPUP_HELP_IN_BROWSER:
          'Åbner nye vinduer i en ekstern IE browser. Disse kan automatiseres og vil ikke lukkes sammen med den app hvorfra de er åbnet.',
        POPUP_HELP_IN_INTERNALWINDOW:
          'Åbner nye vinduer i et internt vindue. Popups kan ikke automatiseres og vil lukkes igen sammen med den app hvorfra de er åbnet.',
        REFERENCES: 'refererer til {thing}',
        SIZE: 'størrelse',
        FILTER_FLOWS_PROPERTY: 'Hvad der skal matche',
        FILTER_FLOWS_OPERATOR: 'Hvordan der skal matches',
        FILTER_FLOWS_VALUE: 'Værdien der skal matches',
        STATE_SUBJECT: 'Tilstands nøgle',
        HAS: 'Har  {thing}',
        COUNT: 'Antal af {thing}',
        SEARCH_OPERATOR_IS_TRUE: 'Er sandt (true)',
        SEARCH_OPERATOR_IS_FALSE: 'Er ikke sandt (false)',
        CHOOSE_COLUMNS: 'Vælg kolonner',
        BROWSER: 'en ekstern browser',
        INTERNAL_WINDOW: 'et internt vindue',
        DETACH_SECTION: 'Afkobling af app',
        WINDOW_BEHAVIOR_ON_DETACH: 'Muligheder for vindue',
        CLOSE_WINDOW_ON_DETACH: 'Luk vinduet når app afkobles',
        LET_WINDOW_REMAIN_OPEN_ON_DETACH: 'Lad vinduet forblive åbent',
        USE_GLOBAL_SETTING: 'Brug den globale indstilling',
        WARN_SAVE_WITH_ERRORS: 'Gemmer med fejl',
        WARN_COLUMN_NOT_SORTABLE: 'Kolonnen "{column}" kan ikke sorteres',
        LOCALIZATION: 'Lokalisering',
        I18N_CUESTA: 'Cuesta',
        I18N_MANATEE_STRINGS: 'Manatee (strenge)',
        I18N_MANATEE_RESOURCES: 'Manatee (resourcer)',
        HUB: 'hub | hubs',
        FLOW_IS_DOWNLOADED: 'Flow er hentet fra en hub i version {version}',
        TOKEN: 'token',
        PUBLICATIONS_FROM: 'Alt publiceret fra denne CMR til {hub}.',
        PUBLICATION_TYPE: 'publikations type',
        PUBLICATION_NAME: 'navn',
        PUBLICATION_APP: 'publikations app',
        LICENSE: 'licens | licenser',
        CATEGORY: 'kategori | kategorier',
        PUBLICATION_VERSION: 'version',
        PUBLICATION: 'publikation | publikationer',
        ABSTRACT: 'Kort beskrivelse',
        RELEASENOTE: 'release-note',
        PUBLISH_NEW: 'Publicer ny version',
        CHANGES_SINCE: '{count} ændringer siden sidste publikation',
        NOT_PUBLISHED: 'Denne {thing} er ikke blevet publiceret',
        LAST_MODIFIED: 'sidst ændret',
        FILENAME: 'Filnavn',
        EDIT_PUBLICATION_HEADER:
          'Du kan nu ændre i de publicerede information og klikke "gem" for at gemme. Dette vil ikke oprette en ny version, men kun ændre en eksisterende.',
        PUBLISH_NEW_HEADER: 'Publicer en ny eller opdateret version af dette flow til {hub} hub.',
        NAME_OF: 'Navn for {thing}',
        DESCRIPTION_OF: 'Beskrivelse af {thing}',
        LICENSE_TEMPLATE: 'licens skabelon',
        NO_ATTACHMENTS: 'Ingen vedhæftede filer. Træk filer her for at vedhæfte.',
        PUBLICATION_TYPE_FLOW_NAME: 'Enkelt flow',
        PUBLICATION_TYPE_FLOW_DESC:
          '<p>Et enkelt flow bliver publiceret som det er uden ændringer. Dvs at der kan mangle felter etc som refereres fra flowet når det bliver downloaded.</p><p>Efter download kan brugere både redigere og se koden for flowet. Brug denne type hvis flowet er ment som en inspiration og hvis alt der skal til at køre flowet allerede er indeholdt i flowet.</p>',
        PUBLICATION_TYPE_INLINED_FLOW_NAME: 'Komplet flow',
        PUBLICATION_TYPE_INLINED_FLOW_DESC:
          '<p>Et komplet flow bliver kørt igennem en process hvor vi samler alle eksterne referencer (felter, flows etc) og lægger dem ind i selve koden.</p><p>Brugere der downloaded flowet vil ikke kunne se eller ændre koden, til gengæld er det sikkert for dem at opdatere flowet til nye publicerede versioner. Brug denne type hvis du publicerer noget der kun kræver mindre tilrettelser (via extensions) når det er downloaded.</p>',
        MARKDOWN_EDITOR_HELP: 'Du kan bruge markdown her.',
        DROP_HERE_TO_ATTACH: 'Drop filer her for at vedhæfte dem.',
        SAVE: 'Gem',
        GET: 'Hent {thing}',
        HUB_SEARCH_AND_GET_HEADER: 'Opdater eksisterende flows eller hent nye',
        HUB_SEARCH_AND_GET_BODY:
          'Find det flow der skal opdateres eller hentes via felterne nedenfor. Du kan her se alle flows fra alle konfigurede hubs.',
        ALREADY_NEWEST: 'Flowet er allerede hentet i den nyeste version.',
        GOTO: 'Gå til "{destination}".',
        UPDATE_VERSION_ON_RELEASE_NOTE:
          'Du skal ændre den releasede version inden du kan publicere flowet.',
        MISSING_NAME: 'Du skal angive et navn.',
        HAS_UPDATE: 'En ny version er tilgængelig. Du kan opdatere til den nyeste version her.',
        HAS_LOCAL_CHANGES:
          'Flowet har lokale ændringer. Du kan opdatere fra hub, men det vil overskrive de ændringer du har lavet.',
        OVERWRITE_LOCAL_CHANGES_HEADER: 'Overskriv lokale ændringer?',
        OVERWRITE_LOCAL_CHANGES_BODY:
          'Er du sikker på at du vil hente den nyeste version og dermed overskrive lokale ændringer?',
        WAS_INSTALLED: '{thing} blev hentet',
        WAS_NOT_INSTALLED: '{thing} blev ikke hentet',
        WAS_PUBLISHED: '{thing} blev publiceret',
        WAS_NOT_PUBLISHED: '{thing} blev ikke publiceret',
        WAS_NOT_DELETED: '{thing} blev ikke slettet',
        CHOOSE_APP_FOR_INSTALL: 'Vælg hvilken app flowet "{name}" skal installeres i',
        ALREADY_INSTALLED:
          'Flowet "{name}" er allerede installeret. Du kan kun installere et publiceret flow 1 gang.',
        NO_SUCH: '{thing} findes ikke.',
        INL_FIELD_NAME_IS_NO_LITERAL: 'Felt navn må ikke være dynamisk. Fra "{flowName}".',
        INL_NO_SUCH_FIELD: 'Intet field kaldet "{name}" i "{flowName}".',
        INL_FIELD_HAS_ALTERNATIVES: 'Felter med alternativer kan ikke inlines i "{flowName}".',
        INL_NO_NAME_FOR_FLOW: 'Flow mangler et navn i "{flowName}".',
        INL_FLOW_NAME_IS_NO_LITERAL: 'Flow navn må ikke være dynamisk i "{flowName}".',
        INL_NO_SUCH_FLOW: 'Intet flow kaldet "{name}" i "{flowName}".',
        INL_NO_SUCH_FLOW_ON_APP: 'Intet flow kaldet "{name}" i denne app. Fra "{flowName}".',
        INL_SERVICE_CANNOT_BE_INLINED: 'Services kan ikke inlines i "{flowName}".',
        INLINE_ERROR_HEADER: 'Inline fejl',
        INLINE_ERROR_MESSAGE_FALLBACK: 'Kører flow direkte: {error}',
        CONNECT_TO: 'Forbind til {thing}',
        ERR_LOADING_FROM_HUB: 'Kunne ikke hente data fra hub: {err}',
        ENVIRONMENT: 'Miljø',
        HOME_HEADER: 'Velkommen til {productName}',
        HOME_BODY:
          'Du kan bruge {productName} som et værktøj til at kode automatisering til Manatee og konfigure hvornår de skal køre, for hvem de er tilgængelige og hvordan de skal eksekveres.',
        NO_LANDING_PAGE_CONFIGURATION_HEADER:
          'Du har ikke konfigureret denne del af hovedsiden endnu',
        NO_LANDING_PAGE_CONFIGURATION_BODY:
          'Gå til <a href="#/configuration/preferences">bruger indstillinger</a> for at konfigurere hvad der skal vises her.',
        NO_SAVED_SEARCHES:
          'Ingen gemte søgninger. Gå til <a href="#/flows">flows siden</a> for at konfigurere og gemme en søgning der kan vises her.',
        SAVED_SEARCH: 'gemt søgning | gemte søgninger',
        ENTRY: 'vist | viste',
        PREFERENCES_LANDING_PAGE: 'Hovedsiden',
        PREFERENCE_LP_HEADER: 'Konfigurer hvad der skal vises på hovedsiden',
        PREFERENCE_LP_BODY: 'Du kan her angive 3 elementer der skal vises på hovedsiden.',
        LAST_EDITS: 'Sidst redigeret',
        NOTHING_EDITED:
          'Der er ingen information om dine sidst redigerede flows, apps, felter eller tabeller. Prøv at redigere en af disse og vend så tilbage hertil.',
        PREFERENCES_SECURITY: 'Sikkerhed',
        '2FA_PREFERENCE_DESCRIPTION':
          'Aktiver 2-faktor login. Du skal bruge en app der kan generere engangskoder, e.g. Google Authenticator eller 1Password.',
        '2FA_ENABLED': '2-faktor login',
        ENABLE_2FA_HEADER: '2-faktor login',
        ENABLE_2FA_QR:
          'Scan QR koden i din authenticator app og indtast den kode der genereres nedenfor.',
        ENABLE_2FA_SECRET_HEADER: 'Manuel kode',
        ENABLE_2FA_SECRET_BODY:
          'Som et alternativ til at scanne QR koden kan du muligvis manuelt skrive nedenstående kode ind i din app.',
        ENABLE_2FA_TOTP_HEADER: 'Engangskode',
        ENABLE_2FA_TOTP_BODY: 'Indtast engangskode her for at aktivere 2-faktor login.',
        PREFERENCES_PROFILE_PICTURE: 'Profil Billede',
        PROFILE_PICTURE_DESCRIPTION:
          'Cuesta vil automatisk bruge det billede, som er uploadet til profilen på gravatar.com med din email. Ellers kan du uploade et billede her, som vil bruges i stedet for',
        PROFILE_PICTURE_RESET: 'nulstil',
        PROFILE_PICTURE_UPLOAD: 'upload',
        PROFILE_PICTURE_SIZE_EXCEED: 'Billedet er for stort',
        PROFILE_PICTURE_TYPE_ERROR: 'Vælg et gyldigt billede',
        PROFILE_ICON_TITLE: 'Profile Billede',
        TOTP: 'Engangskode',
        '2FA_RECOVERY_CODES':
          'Kopier og gem disse backup koder hvis du skulle miste adgang til din authenticator app.',
        '2FA_VERIFY_CODE': 'Valider kode',
        '2FA_ENTER_RECOVERY_CODE': 'Skift mellem engangs- og backup-kode her.',
        RECOVERY_CODE: 'Backup kode',
        '2FA_ENABLE_AND_VERIFY_CODE': 'Aktiver og log ind',
        '2FA_RECOVERY_CODES_PROCEED': 'Fortsæt',
        LOOKING_FOR: 'Søger efter {thing}. Fundet i {found}.',
        USES_OF: 'brug af "{thing}"',
        LOCATION_COUNT: 'ingen steder | et sted | {count} steder',
        RESTRICTION: 'restriktion | restriktioner',
        RESTRICTION_WARNING:
          'Der eksisterer en restriktion på brugen af {module}.{method} for den version og grupper der er tilknyttet dette flow. Manatee vil gøre følgende når den støder på denne linie; {actions}.',
        RESTRICTION_ACTION_KIND_DENY: 'Afbryd flowet',
        RESTRICTION_ACTION_KIND_PARAM: 'Check parametre',
        RESTRICTION_ACTION_KIND_PROMPT: 'Spørg brugeren',
        RESTRICTION_ACTION_KIND_LOG: 'Skriv til loggen og fortsæt',
        RESTRICTION_PROMPT_DESCRIPTION: 'Beskeden som brugeren promptes med',
        RESTRICTION_TIMEOUT_DESCRIPTION: 'Timeout for prompt',
        RESTRICTION_LOG_MESSAGE: 'Beskeden der bliver skrevet til loggen',
        RESTRICTION_TARGET_HEADER: 'Gruppen og versionen der skal angives restriktioner for',
        RESTRICTION_HEADER: 'Restriktioner',
        METHOD: 'metode',
        PROMPT_LABEL: 'Spørg bruger',
        PARAM_LABEL: 'Check parametre',
        LOG_LABEL: 'Log og fortsæt',
        DENY_LABEL: 'Afbryd',
        RESTRICTION_GROUP_VERSION_NOT_UNIQUE: 'Gruppen og versionen skal være unikke',
        SHOW: 'Vis {thing}',
        HIDE: 'Gem {thing}',
        AFFECTED: 'Påvirkede {thing}',
        RESTRICTION_TYPE: 'Restriktions-type',
        RESTRICTION_PARAM_BODY: 'Hvilke inputs skal tjekkes og hvad skal de matche.',
        RESTRICTION_ACTION_BODY: 'Hvilken handling skal foretages når parametrene matcher.',
        EXTENSION: 'udvidelse | udvidelser',
        EXTENSIONS_DESCRIPTION:
          'Følgende udvidelser er defineret i flowet. Disse kon konfigureres når flowet hentes fra hub af slut-brugeren. Lav fyldestgørende tekster her der beskriver hvilken information der skal bruges og hvad den bruges til.',
        EXTENSION_STRING_DESCRIPTION:
          'Den givne streng skal matche det regulære udtryk <b class="monospaced">{match}</b>.',
        EXTENSIONS_INPUT_DESCRIPTION:
          'Udvidelserne nedenfor er information som skal bruges i flowet for at tilpasse det til brugssituationen og miljøet det skal køre i.',
        EXTENSION_SELECTION_DESCRIPTION: 'Tilgængelige muligheder er; {options}',
        EXTENSION_CODE_DESCRIPTION: '',
        EXTENSION_FIELD_DESCRIPTION: '',
        EXTENSION_FLOW_DESCRIPTION: '',
        EXTENSION_HEADER: 'Udvidelse med navn <emph>{name}</empty> der giver en {type}',
        EXTENSION_FIELD_INPUT_FOR: 'Vælg et felt for {name}',
        EXTENSION_FLOW_INPUT_FOR: 'Vælg et flow med {name}',
        EXTENSION_SELECTION_INPUT_FOR: 'Vælg en værdi for {name}',
        EXTENSION_STRING_INPUT_FOR: 'Indtast en værdi for {name}',
        EXTENSION_TABLE_INPUT_FOR: 'Vælg en tabel for {name}',
        INPUTS: '{list} som input',
        NO_INPUTS: 'ingen input',
        CACHE_HEADER: 'Cuesta cache',
        CACHE_FLUSH_BUTTON_TEXT: 'Tøm cachen nu',
        JOBS: 'jobs',
        ANALYZE_CODE: 'analyser kode',
        PREPARE_CACHE: 'forbered cache',
        READ_MANY_FROM_CACHE: 'indlæs {typename} fra cache',
        APPLICATION_TYPE: 'app type | app typer',
        MANATEE_SETTINGS: 'manatee indstillinger',
        READ_CHANGED_FROM_SERVER: 'læs ændrede {typename} fra server',
        APPLY_DELTAS: 'opdater cachede {typename}',
        GET_BY_ID: 'hent {typename}',
        GET_BY_NAME: 'hent {typename}: {name}',
        GET_FOR_APP: 'hent {typename} for app',
        GET_FOR_MAINTAINER: 'hent {typename}',
        SAVE_TYPE: 'gem {typename}',
        CREATE_TYPE: 'opret {typename}',
        DELETE_TYPE: 'slet {typename}',
        MATCHES_EXACT_MD: 'matcher præcist `{value}`.',
        MATCHES_REGEX_MD: 'matcher det regulære udtryk `{value}`.',
        MATCHES_WILDCARD_MD: 'matcher en vilkårlig værdi i det nuværende niveau',
        MATCHES_DEEPWILD_MD: 'matcher en vilkårlig værdi rekursivt i træet',
        MATCHES_CONTAINS_MD: 'matcher hvor `{value}` er indeholdt i en værdi på elementet.',
        MATCHES_ENDSWITH_MD: 'matcher hvor `{value}` er et suffix af en egenskab på elementet.',
        MATCHES_STARTSWITH_MD: 'matcher hvor `{value}` er et præfix af en egenskab på elementet.',
        MATCHES_WINDOW_MD: 'matcher det vindue der indeholder `{value}` i titlen ',
        MATCHES_GLOBAL_MD: 'i alle vinduer på desktoppen.',
        MATCHES_LOCAL_MD: 'i et undervindue.',
        RELATION_ABOVE_MD: 'dette element bruges til at finde et andet element *nedenunder* som',
        RELATION_BELOW_MD: 'dette element bruges til at finde et andet element *ovenover* som',
        RELATION_LEFT_MD: 'dette element bruges til at finde et andet element *til højre for* som',
        RELATION_RIGHT_MD:
          'this element will be used to find another element *to the left of* which',
        RELATION_NEAREST_MD: 'dette element bruges til at finde det andet element *tættest på* som',
        RELATION_SIBLING_MD: 'dette element bruges til at finde et andet *søskende* element som',
        RELATION_CHILD_MD: 'dette element bruges til at finde et andet *barn* af elementet som',
        ONLYVISIBLE_MD: 'kun synlige elementer medtages i søgningen.',
        HINT_MD: 'kun værdier af typen `{value}` på elementet medtages i søgningen',
        NO_HINT_MD: 'alle værdier på elementet medtages i søgningen.',
        INDEX_MD: 'match nummer `{value}` af alle matchende elementer vil vælges.',
        TOKEN_TARGET_HEADER: 'Det endelige mål for stien',
        MATCH_HINT_MENU_HEADER: 'Matchende egenskab',
        MATCH_HINT_ALL: 'Alle egenskaber',
        MATCH_HINT_TEXT: 'Match tekst indhold',
        MATCH_HINT_ID: 'Match id',
        MATCH_HINT_TYPE: 'Match kontrol-typen',
        MATCH_HINT_CLASS: 'Match kontrol-klassen',
        MATCH_HINT_NAME: 'Match navn på kontrol',
        MATCH_HINT_LEGACYVALUE: 'Match "legacy" værdi',
        MATCH_TYPE_MENU_HEADER: 'Match metode',
        MATCH_TYPE_EXACT: 'Match indhold præcist',
        MATCH_TYPE_REGEX: 'Via et regulært udtryk',
        MATCH_TYPE_STARTSWITH: 'Via præfiks',
        MATCH_TYPE_ENDSWITH: 'Via suffiks',
        MATCH_TYPE_CONTAINS: 'Indeholder',
        MATCH_TYPE_WILDCARD: 'Matcher alt',
        MATCH_TYPE_DEEPWILD: 'Matcher alt rekursivt',
        MATCH_TEXT: 'Match værdi',
        MATCH_INDEX: 'Index',
        TOKEN_RELATION_ADD: 'Yderligere match skridt',
        TOKEN_REF_HEADER: 'Reference kontrol',
        TOKEN_RELATION_HEADER: 'Relation ml reference/mål',
        CHILD_OF_TITLE: 'Målet er forælder til referencen.',
        SIBLING_OF_TITLE: 'Målet er søskende til referencen.',
        'LEFT-OF_TITLE': 'Målet kan findes til højre for referencen.',
        'RIGHT-OF_TITLE': 'Målet kan findes til venstre for referencen.',
        ABOVE_TITLE: 'Målet kan findes under referencen.',
        BELOW_TITLE: 'Målet kan findes over referencen.',
        NEAREST_TITLE: 'Målet er den kontrol der er matcher tættest på referencen.',
        RELATION: 'relation | relationer',
        MATCH_WINDOW_REGEX: 'Regex til titel match',
        TOKEN_WINDOW_GLOBAL: 'Forsøg m alle vinduer på desktop',
        TOKEN_INCLUDE_INVISIBLE: 'Inkluder usynlige kontroller',
        RIGHT_CLICK_TO_EDIT: 'Højre-klik for at vise redigerings-menu.',
        FIELD_PATH_SETTINGS: 'Indstillinger',
        HIGHLIGHT: 'Marker felt i app',
        USE_AS_FIELD_PATH: 'Benyt sti til dette felt',
        FIELD_TREE: 'Træ',
        PROPERTIES_OF: 'Egenskaber ved {thing}',
        FIELD_TREE_EXPAND_ALL: 'Udvid hele træet',
        FIELD_SEARCH: 'Søg i træet',
        FIELD_TREE_NONE_HTML:
          'Tryk på <span class="ui mini green icon button"><i class="refresh icon"></i></span> knappen ovenfor for at bygge en træ-repræsentation af brugergrænsefladen for denne application.',
        CHOOSE: 'Vælg {thing}',
        FLOW_CANNOT_DELETE_LAUNCH_HELP: 'Flow kan ikke slettes da det bruges til at starte app.',
        CHAT_SERVICE: 'Chat',
        CHAT_SERVICE_TYPE: 'Type',
        CHAT_SERVICE_TYPE_SLACK: 'Slack',
        SLACK: 'Slack indstillinger',
        SLACK_APP_TOKEN: 'App token',
        SLACK_APP_TOKEN_PLACEHOLDER: 'Indtast slack app token her',
        SLACK_APP_TOKEN_HELP:
          'App token bruges til at lytte efter nye beskeder hvis service bruges som trigger. Du skal have sat <code>connections:write</code> scope på dit app token for at dette virker.',
        SLACK_BOT_USER_TOKEN: 'Bot user token',
        SLACK_BOT_USER_TOKEN_PLACEHOLDER: 'Indtast slack bot user token her',
        SLACK_BOT_USER_TOKEN_HELP:
          'Bot user token bruges til at læse og skrive beskeder i de for robotten tilgængelige kanaler. Du skal have følgende scopes på dit bot token:<p><ul><li><code>channels:read</code></li><li><code>channels:history</li><li><code>chat:write</code></li><li><code>users:read</code></li><li><code>im:read</code></li><li><code>npim:read</code></li></ul></p>',
        CHAT_SERVICE_TRIGGER: 'Chat',
        CHAT_SERVICE_TRIGGER_META:
          'Start flows når der modtages en besked der matcher nedenstående kriterier.',
        CHAT_CHANNEL: 'Kanal',
        CHAT_FROM: 'Fra',
        CHAT_MESSAGE: 'Besked',
        ALERT_RULE: 'alarm regel | alert regler',
        ALERT_RULE_NAME: 'Navn',
        ALERT_RULE_ENABLED: 'Aktiv',
        ALERT_RULE_CONDITION: 'alarm betingelse | alert betingelser',
        ALERT_RULE_INTERVAL: 'Interval',
        EVERY: 'hvert',
        MINUTE: 'minut | minutter',
        ALERT_RULE_HITS: 'Aktiveringer',
        REQUIRE: 'kræv',
        HITS_TO_ACT: 'aktivering for at agere | aktiveringer for at agere',
        ALERT_RULE_CONDITION_QUERY: 'Forespørgsel',
        ALERT_RULE_QUERY_CONDITION_LABEL: 'Aktiver alarm når følgende gælder',
        ALERT_RULE_CONDITION_FLOW: 'Flow',
        ALERT_RULE_FLOW_LAUNCH_HELP:
          'Vælg flow der skal køres. Output fra dette flow vil afgøre om alarmen aktiveres. Hvis du returnerer en værdi fra dit flow vil alarmen blive aktiveret.',
        ALERT_RULE_ACTION: 'alarm handling | alarm handlinger',
        ALERT_ACTION_TYPE_MAIL: 'Email',
        ALERT_ACTION_TYPE_CHAT: 'Chat',
        EMAIL_BODY: 'Besked',
        EMAIL_SUBJECT: 'Emne',
        ALERT_TARGETS: 'Alarm gælder kun for <b>{user}</b> på maskinen <b>{machine}</b>.',
        ALERT: 'alarm | alarmer',
        ALERT_RULE_TARGET: 'Mål for alarm',
        MACHINE: 'maskine | maskiner',
        ALERT_LAST_INACTIVE: 'Alarm var grøn sidst {time}',
        ALERT_IS_ACTIVE: 'Alarm er aktiv',
        ESTERO_ALERT: 'Alarm',
        ESTERO_ALERT_LOG: 'Alarm log',
        NOW: 'lige nu',
        ALERT_MESSAGE_INTERPOLATION: 'Beskeden fra e.g. det flow der aktiverede alarmen.',
        ALERT_RULE_CONDITION_DESC:
          'Vælg en betingelse for at aktivere alarmen. Alarmen vil kun aktiveres hvis denne betingelse er opfyldt.',
        ALERT_RULE_ACTIONS_DESC: 'Vælg en handling der skal eksekveres når alarmen aktiveres.',
        GROUP_INCLUDED_IN_GROUP_DESCRIPTION:
          'En liste af grupper som <b>denne gruppe</b> er inkluderet i.'
      }
    },
    typename: 'locale'
  }
]

export default locales
// Use this for the i18n script
//module.exports = locales
